<template>
  <main class="rd-wrap">
    <div id="reserdetail">
      <section class="rd-section">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-10">

              <!-- 페이지 헤더 -->
              <div class="rd-page-header">
                <div class="rd-header-badge">
                  <span style= "font-size: 1.1rem;">🗃️</span>
                  <span style= "font-size: 1.1rem; font-weight: 800;" v-if="ctCode==='N'">NBUS</span>
                  <span style= "font-size: 1.1rem; font-weight: 800;" v-else-if="ctCode==='H'">HOTEL</span>
                  <span style= "font-size: 1.1rem; font-weight: 800;" v-else>TRIP / TICKET / PASS</span>
                </div>
                <h1 class="rd-page-title" v-if="ctCode==='N'">엔버스 상세내역</h1>
                <h1 class="rd-page-title" v-else-if="ctCode==='H'">호텔 예약상세</h1>
                <h1 class="rd-page-title" v-else>예약 상세내역</h1>
                <p class="rd-page-sub">예약하신 내용을 확인하세요</p>
              </div>


              <!-- ============================
                  ✅ 호텔 예약 섹션
              ============================= -->

              <!-- ① 호텔 헤더 카드 -->
              <div class="rd-card rd-product-card" v-if="ctCode === 'H'">

                <!-- 호텔 이미지 (RtxRoomPlanB2C 패턴) -->
                <div style="width:100%; height:220px; overflow:hidden; background:#f0f4f8;">
                  <img v-if="hotelDetailInfo.heroImg" :src="`${$store.state.rakutenImageHost}/${hotelBookingInfo.hotel_id}/${hotelDetailInfo.heroImg}`" style="width:100%; height:220px; object-fit:cover; display:block;" @error="e => e.target.style.display='none'" />
                  <div v-else style="width:100%; height:220px; display:flex; align-items:center; justify-content:center; font-size:3rem; background:#f0f4f8;">
                    🏨
                  </div>
                </div>

                <!-- 호텔명 + 예약번호 + 상태 + 문의버튼 -->
                <div style="padding:1.2rem 1.6rem; display:flex; align-items:center; gap:1rem; flex-wrap:wrap;">
                  <div style="flex:1;">
                    <div style="font-size:0.72rem; color:#888; font-weight:600; letter-spacing:.06em; margin-bottom:.2rem;">
                      HOTEL BOOKING
                    </div>
                    <div style="font-size:1.2rem; font-weight:800; color:#1a1a2e; margin-bottom:.2rem;">
                      {{ hotelBookingInfo.hotel_name }}
                    </div>
                    <div v-if="hotelDetailInfo.original_name"
                        style="font-size:0.8rem; color:#888; margin-bottom:.4rem;">
                      {{ hotelDetailInfo.original_name }}
                    </div>
                    <div style="display:flex; align-items:center; gap:.6rem; flex-wrap:wrap;">
                      <span style="font-size:0.82rem; font-weight:700; color:#1a6eb5;">
                        {{ hotelBookingInfo.booking_no }}
                      </span>
                      <span :class="['status-badge-h', hotelStatusClass(hotelBookingInfo.status)]">
                        {{ hotelStatusText(hotelBookingInfo.status) }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <button class="rd-action-btn" @click="goToCustomerAsk()">
                      <i class="bi bi-chat-dots"></i> 문의하기
                    </button>
                  </div>
                </div>

                <!-- 예약 요약 바 -->
                <div style="background:#f0f4ff; padding:.75rem 1.4rem; border-top:1px solid #e2e8f0;
                            display:flex; align-items:center; gap:1.2rem; flex-wrap:wrap;
                            font-size:.85rem; color:#444;">
                  <span>📅 {{ getDateFormat(hotelBookingInfo.check_in) }} ~ {{ getDateFormat(hotelBookingInfo.check_out) }}</span>
                  <span style="color:#ddd;">|</span>
                  <span>🌙 {{ hotelBookingInfo.night_count }}박</span>
                  <span style="color:#ddd;">|</span>
                  <span>👥 성인 {{ hotelBookingInfo.adult_count }}명 · {{ hotelBookingInfo.room_count }}실</span>
                </div>

                <!-- 구글맵 (RtxRoomPlanB2C 패턴) -->
                <div v-if="hotelDetailInfo.latitude && hotelDetailInfo.longitude" style="border-top:1px solid #e2e8f0; border-radius:0 0 14px 14px; overflow:hidden;">
                  <div id="hotel-detail-map" style="width:100%; height:300px;"></div>
                </div>

              </div>

              <!-- ② 예약 정보 -->
              <div class="rd-card" v-if="ctCode === 'H'">
                <div class="rd-card-header">
                  <i class="bi bi-calendar-check"></i>
                  <span>예약 정보</span>
                </div>
                <div class="rd-card-body">
                  <div class="rd-info-grid">
                    <div class="rd-info-item">
                      <span class="rd-info-label">체크인</span>
                      <span class="rd-info-value" style="font-weight:700; color:#1a6eb5;">
                        {{ getDateFormat(hotelBookingInfo.check_in) }}
                      </span>
                    </div>
                    <div class="rd-info-item">
                      <span class="rd-info-label">체크아웃</span>
                      <span class="rd-info-value" style="font-weight:700; color:#1a6eb5;">
                        {{ getDateFormat(hotelBookingInfo.check_out) }}
                      </span>
                    </div>
                    <div class="rd-info-item">
                      <span class="rd-info-label">숙박 / 인원 / 객실</span>
                      <span class="rd-info-value">
                        {{ hotelBookingInfo.night_count }}박 /
                        성인 {{ hotelBookingInfo.adult_count }}명 /
                        {{ hotelBookingInfo.room_count }}실
                      </span>
                    </div>
                    <div class="rd-info-item">
                      <span class="rd-info-label">객실</span>
                      <span class="rd-info-value">{{ hotelBookingInfo.room_desc || '-' }}</span>
                    </div>
                    <!-- 호텔승인코드 -->
                    <div class="rd-info-item" v-if="hotelBookingInfo.hotel_conf_id">
                      <span class="rd-info-label">Hotel Confirmation ID</span>
                      <span class="rd-info-value" style="color:#2c7a4b; font-weight:700; font-size:1rem;">
                        {{ hotelBookingInfo.hotel_conf_id }}
                      </span>
                    </div>
                    <div class="rd-info-item rd-info-item--full" v-if="hotelBookingInfo.special_request">
                      <span class="rd-info-label">특별요청사항 &nbsp;<span style="color: red;">(※ 현지 참고용 전달사항으로 보장되지 않습니다)</span></span>
                      <span class="rd-info-value">{{ hotelBookingInfo.special_request }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ③ 투숙객 정보 -->
              <div class="rd-card" v-if="ctCode === 'H' && hotelBookingGuests.length > 0">
                <div class="rd-card-header">
                  <i class="bi bi-people"></i>
                  <span>투숙객 정보</span>
                </div>
                <div class="rd-card-body">
                  <div v-for="(g, i) in hotelBookingGuests" :key="i" style="padding:.7rem 1rem; background:#f8f9ff; border-radius:8px; border:1px solid #e2e8f0; margin-bottom:.6rem;">
                    <div style="display:flex; align-items:center; gap:.6rem; font-size:.85rem;">
                      <span style="font-weight:700; color:#1a6eb5;">{{ i+1 }}호실</span>
                      <span style="font-weight:600; color:#1a1a2e;">
                        {{ g.salutation }} {{ g.first_name }} {{ g.last_name }}
                      </span>
                      <span style="font-size:.75rem; color:#888;">({{ g.nationality }})</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ④ 예약자 정보 -->
              <div class="rd-card" v-if="ctCode === 'H'">
                <div class="rd-card-header">
                  <i class="bi bi-person-circle"></i>
                  <span>예약자 정보</span>
                </div>
                <div class="rd-card-body">
                  <div class="rd-info-grid">
                    <div class="rd-info-item">
                      <span class="rd-info-label">성명</span>
                      <span class="rd-info-value">{{ hotelBookingInfo.contact_name }}</span>
                    </div>
                    <div class="rd-info-item">
                      <span class="rd-info-label">연락처</span>
                      <span class="rd-info-value">{{ hotelBookingInfo.contact_no }}</span>
                    </div>
                    <div class="rd-info-item rd-info-item--full">
                      <span class="rd-info-label">이메일</span>
                      <span class="rd-info-value">{{ hotelBookingInfo.contact_email }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ⑤ 결제 정보 -->
              <div class="rd-card" v-if="ctCode === 'H'">
                <div class="rd-card-header">
                  <i class="bi bi-credit-card"></i>
                  <span>결제 정보</span>
                </div>
                <div class="rd-card-body">
                  <div class="rd-pay-summary">
                    <div class="rd-pay-row rd-pay-row--total">
                      <span class="rd-pay-label fs-6">총결제금액</span>
                      <span class="rd-pay-value rd-pay-value--total">
                        {{ getCurrencyFormat(hotelBookingInfo.selling_krw) }}<em>원</em>
                      </span>
                    </div>
                    <div class="text-end text-secondary">
                      <span style="font-size: small;">( {{ this.getKorDateFormat(hotelBookingInfo.paidDate) }} )</span>
                    </div>
                  </div>
                  <div v-if="hotelBookingInfo.cancel_remarks || cancelPolicyDetails.length > 0" style="background:#fffbeb; border:1px solid #fde68a; border-radius:8px; padding:1rem 1.2rem; margin-top:.8rem;">
                    <div style="font-size:.82rem; font-weight:700; color:#b45309; margin-bottom:.6rem;">
                      📋 취소정책
                    </div>

                    <div v-if="hotelBookingInfo.cancel_remarks"
                        style="font-size:.82rem; color:#78350f; line-height:1.7; margin-bottom:.6rem;">
                      {{ hotelBookingInfo.cancel_remarks }}
                    </div>

                    <div v-if="cancelPolicyDetails.length > 0">
                      <div v-for="(p, i) in cancelPolicyDetails" :key="i"
                          :style="{
                            display:'flex', justifyContent:'space-between', alignItems:'center',
                            gap:'.8rem', padding:'.5rem .6rem',
                            borderRadius:'6px',
                            background: p.isCurrent ? '#fff3cd' : 'transparent',
                            border: p.isCurrent ? '1px solid #f5c344' : '1px solid transparent',
                            marginBottom: i < cancelPolicyDetails.length - 1 ? '.3rem' : '0'
                          }">
                        <span style="font-size:.78rem; color:#78350f;">
                          {{ p.label }}
                          <span v-if="p.isCurrent" style="font-size:.7rem; font-weight:700; color:#b45309; margin-left:.4rem;">
                            (현재 적용)
                          </span>
                        </span>
                        <span :style="{ fontSize:'.8rem', fontWeight:'700', color: p.percentColor, whiteSpace:'nowrap' }">
                          {{ p.percentText }}
                        </span>
                      </div>
                      <p style="font-size:.72rem; color:#aaa; margin:.6rem 0 0;">
                        ※ 시간은 한국 표준시(KST) 기준입니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ⑥ 호텔 하단 버튼 -->
              <div class="rd-footer-btns" v-if="ctCode === 'H'">
                <button type="button" class="rd-footer-btn rd-footer-btn--main" @click="goToMypage()">
                  <i class="bi bi-house"></i> 마이페이지로
                </button>

                <!-- 예약확정 상태일 때만 취소 버튼 표시 -->
                <button type="button" class="rd-footer-btn rd-footer-btn--cancel" @click="reqCancelHotel()" v-if="hotelBookingInfo.status === 'bkg-cf'" :disabled="hotelCancelLoading">
                  <i class="bi bi-x-circle"></i>
                  {{ hotelCancelLoading ? '처리 중...' : '예약 취소' }}
                </button>

                <!-- 이미 취소됨 -->
                <button type="button" class="rd-footer-btn rd-footer-btn--cancel" disabled v-else-if="hotelBookingInfo.status === 'bkg-cx'">
                  <i class="bi bi-check-circle"></i> 취소완료
                </button>
              </div>


              <!-- ============================
                  기존 섹션들 (ctCode !== 'H')
              ============================= -->

              <!-- 상품 / 엔버스 안내 카드 -->
              <div class="rd-card rd-product-card" v-if="ctCode !== 'H'">

                <!-- 엔버스 상품 -->
                <div v-if="ctCode === 'N'" class="rd-nbus-header">
                  <div class="rd-nbus-icon">
                    <i class="bi bi-bus-front-fill"></i>
                  </div>
                  <div class="rd-nbus-info">
                    <p class="rd-label">엔버스 번호</p>
                    <p class="rd-nbus-code">{{ this.reserveInfo.inqCode }}</p>
                  </div>
                  <div class="rd-product-actions">
                    <button class="rd-action-btn" @click="goToCustomerAsk()">
                      <i class="bi bi-chat-dots"></i> 문의하기
                    </button>
                    <button class="rd-action-btn rd-action-btn--outline" @click="toReview(this.reqRsvCode)">
                      <i class="bi bi-star"></i> 후기작성
                    </button>
                  </div>
                </div>

                <!-- 일반 상품 -->
                <div v-else class="rd-product-header">
                  <div class="rd-product-img-wrap">
                    <img v-if="this.productImage.imgName != undefined" :src="`/download/${this.productId}/${this.productImage.imgName}`" class="rd-product-img" alt="상품이미지">
                    <img v-else :src="`/download/noImage/noImage.jpg`" class="rd-product-img" alt="상품이미지">
                  </div>
                  <div class="rd-product-meta">
                    <span class="rd-product-code">{{ this.productInfo.pdtCode }}</span>
                    <h2 class="rd-product-name">{{ this.productInfo.pdtNameKor }}</h2>
                    <div class="rd-reserve-code-wrap">
                      <span class="rd-label">예약번호</span>
                      <span class="rd-reserve-code">{{ this.reserveInfo.reqReserveCode }}</span>
                    </div>
                    <div class="rd-product-actions">
                      <button class="rd-action-btn" @click="goToProductDetail(this.productInfo.pdtCode)">
                        <i class="bi bi-box-arrow-up-right"></i> 상품보기
                      </button>
                      <button class="rd-action-btn" @click="goToCustomerAsk()">
                        <i class="bi bi-chat-dots"></i> 문의하기
                      </button>
                      <button class="rd-action-btn rd-action-btn--outline" @click="toReview(this.reqRsvCode)">
                        <i class="bi bi-star"></i> 후기작성
                      </button>
                    </div>
                  </div>
                </div>
              </div>


              <!-- 여행 일정 정보 -->
              <div class="rd-card" v-if="ctCode !== 'H'">
                <div class="rd-card-header">
                  <i class="bi bi-map"></i>
                  <span v-if="ctCode === 'N'">엔버스 일정/경로</span>
                  <span v-else>여행 일정 정보</span>
                </div>

                <!-- ---- 엔버스 일정 ---- -->
                <div v-if="ctCode === 'N'" class="rd-card-body">

                  <!-- PC -->
                  <div class="pc">
                    <div class="rd-info-grid">
                      <div class="rd-info-item">
                        <span class="rd-info-label">출발일자 (이용일자)</span>
                        <span class="rd-info-value">{{ this.getDateFormat(reserveInfo.rentStartDate) }} <em class="rd-days">({{ reserveInfo.rentTotDays }}일간)</em></span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">인원 / 가이드 / 버스</span>
                        <span class="rd-info-value">{{ this.reserveInfo.personCnt }}인 / {{ reserveInfo.guideLv }} / {{ reserveInfo.busLv }} ({{ reserveInfo.busDetail }})</span>
                      </div>
                    </div>

                    <div class="rd-route-section">
                      <p class="rd-section-sub-title"><i class="bi bi-signpost-split"></i> 일정 / 경로</p>
                      <div :key="i" v-for="(rd, i) in exist_nbRoute" class="rd-route-item">
                        <div class="rd-route-day">{{ i+1 }}일차</div>
                        <div class="rd-route-points">
                          <span class="rd-route-dept">{{ rd.deptPoint }}</span>
                          <i class="bi bi-arrow-right rd-route-arrow"></i>
                          <span class="rd-route-via" v-if="rd.viaPoint">{{ rd.viaPoint }}</span>
                          <i class="bi bi-arrow-right rd-route-arrow" v-if="rd.viaPoint"></i>
                          <span class="rd-route-arr">{{ rd.arrPoint }}</span>
                        </div>
                        <div class="rd-route-time">
                          <i class="bi bi-clock"></i> {{ rd.rentStartTime }} ~ {{ rd.rentCloseTime }}
                        </div>
                      </div>
                    </div>

                    <div class="rd-info-grid rd-mt">
                      <div class="rd-info-item rd-info-item--full">
                        <span class="rd-info-label">담당자 안내사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.addComment" disabled></textarea>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">
                          예약상태
                          <small v-if="this.rpCode === 'nonWP'" class="rd-account-badge">(가상계좌)</small>
                        </span>
                        <div class="rd-status-wrap">
                          <div v-if="this.rpCode === 'nonWP'" class="rd-status-text">{{ this.accPayStatus }}</div>
                          <div v-else>
                            <span class="rd-status-badge rd-status--paid" v-if="this.payStyle === 'f'">전액결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--partial" v-else-if="this.payStyle === 'p'">부분결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--paid" v-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag == 'Y'">결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--request" v-else-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag != 'Y'">결제요청</span>
                            <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.inqStatus === 'PY' && this.reserveInfo.firstPayment == null">결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--cancel" v-else-if="this.reserveInfo.reqStatus === 'CX'"><s>{{ this.reserveInfo.procName }}</s></span>
                            <span class="rd-status-text" v-else-if="this.payStyle != 'f' && this.payStyle != 'p'">{{ this.reserveInfo.procName }}</span>
                          </div>
                          <div v-if="this.cxlFlag === 'Y'" class="rd-cxl-badge"><i class="bi bi-exclamation-circle"></i> 취소요청중</div>
                        </div>
                      </div>
                    </div>

                    <div class="rd-info-grid rd-mt">
                      <div class="rd-info-item">
                        <span class="rd-info-label">예약안내사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.supPrecaution" disabled></textarea>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">취소안내사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.supCancellation" disabled></textarea>
                      </div>
                    </div>
                  </div>

                  <!-- 모바일 -->
                  <div class="mobile">
                    <div class="rd-info-list">
                      <div class="rd-info-row">
                        <span class="rd-info-label">출발일자</span>
                        <span class="rd-info-value">{{ this.getDateFormat(reserveInfo.rentStartDate) }} ({{ reserveInfo.rentTotDays }}일간)</span>
                      </div>
                      <div class="rd-info-row">
                        <span class="rd-info-label">인원/가이드/버스</span>
                        <span class="rd-info-value">{{ this.reserveInfo.personCnt }}인 / {{ reserveInfo.guideLv }} / {{ reserveInfo.busLv }} ({{ reserveInfo.busDetail }})</span>
                      </div>
                      <div class="rd-info-row rd-info-row--col">
                        <span class="rd-info-label">일정/경로</span>
                        <div :key="i" v-for="(rd, i) in exist_nbRoute" class="rd-route-item-mo">
                          <div class="rd-route-day-mo">{{ i + 1 }} 일차</div>
                          <div class="rd-route-mo-grid">
                            <span class="rd-route-mo-label">출발지</span><span class="rd-route-dept">{{ rd.deptPoint }}</span>
                            <span class="rd-route-mo-label">경유지</span><span>{{ rd.viaPoint }}</span>
                            <span class="rd-route-mo-label">도착지</span><span class="rd-route-arr">{{ rd.arrPoint }}</span>
                            <span class="rd-route-mo-label">시작</span><span>{{ rd.rentStartTime }}</span>
                            <span class="rd-route-mo-label">종료</span><span>{{ rd.rentCloseTime }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="rd-info-row rd-info-row--col">
                        <span class="rd-info-label">
                          예약상태
                          <small v-if="this.rpCode === 'nonWP'" class="rd-account-badge">(가상계좌)</small>
                        </span>
                        <div class="rd-status-wrap">
                          <span class="rd-status-badge rd-status--paid" v-if="this.payStyle === 'f'">전액결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--partial" v-else-if="this.payStyle === 'p'">부분결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--paid" v-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag == 'Y'">결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--request" v-else-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag != 'Y'">결제요청</span>
                          <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.inqStatus === 'PY' && this.reserveInfo.firstPayment == null">결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--cancel" v-else-if="this.reserveInfo.inqStatus === 'CX'"><s>{{ this.reserveInfo.procName }}</s></span>
                          <span class="rd-status-text" v-else-if="this.payStyle != 'f' && this.payStyle != 'p'">{{ this.reserveInfo.procName }}</span>
                          <div v-if="this.cxlFlag === 'Y'" class="rd-cxl-badge mt-1"><i class="bi bi-exclamation-circle"></i> 취소요청중</div>
                          <div v-else class="mt-1">
                            <button type="button" class="rd-cxl-btn" @click="reqCxl_nbus(this.reserveInfo.reqReserveCode)">취소요청</button>
                          </div>
                        </div>
                      </div>
                      <div class="rd-info-row rd-info-row--col">
                        <span class="rd-info-label">담당자 안내사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.addComment" readonly></textarea>
                      </div>
                      <div class="rd-info-row rd-info-row--col">
                        <span class="rd-info-label">예약안내사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.supPrecaution" readonly></textarea>
                      </div>
                      <div class="rd-info-row rd-info-row--col">
                        <span class="rd-info-label">취소안내사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.supCancellation" readonly></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ---- 일반 상품 일정 ---- -->
                <div v-else class="rd-card-body">

                  <!-- PC -->
                  <div class="pc">
                    <div class="rd-info-grid">
                      <div class="rd-info-item">
                        <span class="rd-info-label" v-if="productInfo.salesRoute === 'F'">출발일자</span>
                        <span class="rd-info-label" v-else>여행기간</span>
                        <span class="rd-info-value" v-if="!this.reserveInfo.reqDptDate || this.reserveInfo.reqDptDate == 'Invalid date'">-</span>
                        <span class="rd-info-value" v-else-if="productInfo.salesRoute === 'F'">{{ this.reserveInfo.reqDptDate }}</span>
                        <span class="rd-info-value" v-else>{{ this.reserveInfo.reqDptDate }} ~ {{ this.reserveInfo.reqRtnDate }}</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label" v-if="this.dTypeFlag == 'Y'">예약일</span>
                        <span class="rd-info-label" v-else>구매일</span>
                        <span class="rd-info-value">{{ this.reserveInfo.reqDate }}</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">여행지역</span>
                        <span class="rd-info-value">{{ this.productInfo.ntName }} / {{ this.productInfo.arName }}</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">예약상태</span>
                        <div class="rd-status-wrap">
                          <span class="rd-status-badge rd-status--paid" v-if="this.payStyle === 'f' && (this.reserveInfo.reqStatus != 'CO' && this.reserveInfo.reqStatus != 'CX')">전액결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--partial" v-else-if="this.payStyle === 'p' && (this.reserveInfo.reqStatus != 'CO' && this.reserveInfo.reqStatus != 'CX')">부분결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag == 'Y'">결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--request" v-else-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag != 'Y'">결제요청</span>
                          <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.reqStatus === 'PY' && (this.reserveInfo.cstPrice_new === this.reserveInfo.firstPayment || this.reserveInfo.firstPayment == null)">결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--cancel" v-else-if="this.reserveInfo.reqStatus === 'CX'"><s>{{ this.reserveInfo.procName }}</s></span>
                          <span class="rd-status-text" v-else>{{ this.reserveInfo.procName }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="rd-info-grid rd-mt">
                      <div class="rd-info-item">
                        <span class="rd-info-label">출발 → 도착</span>
                        <span class="rd-info-value" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">
                          한국 {{ this.pdtTransInfo1.ddCodeName }} → {{ this.productInfo.ntName }} {{ this.pdtTransInfo1.daCodeName }}
                        </span>
                        <span class="rd-info-value" v-else-if="productInfo.salesRoute == 'L' || productInfo.salesRoute == 'E'">현지일정</span>
                        <span class="rd-info-value" v-else>-</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">출발편</span>
                        <span class="rd-info-value">
                          {{ this.pdtTransInfo1.dmobileCodeName }}
                          <small class="rd-flight-detail" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">
                            ({{ this.pdtTransInfo1.dmobileCode }}{{ this.pdtTransInfo1.dpTpCode }},&nbsp;{{ this.pdtTransInfo1.d_dpTime }} → {{ this.pdtTransInfo1.d_arTime }})
                          </small>
                        </span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">귀국 → 도착</span>
                        <span class="rd-info-value" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">
                          {{ this.productInfo.ntName }} {{ this.pdtTransInfo1.rdCodeName }} → 한국 {{ this.pdtTransInfo1.raCodeName }}
                        </span>
                        <span class="rd-info-value" v-else-if="productInfo.salesRoute == 'L' || productInfo.salesRoute == 'E'">현지일정</span>
                        <span class="rd-info-value" v-else>-</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label" v-if="productInfo.salesRoute == 'T'">귀국편</span>
                        <span class="rd-info-label" v-else>리턴편</span>
                        <span class="rd-info-value">
                          {{ this.pdtTransInfo1.rmobileCodeName }}
                          <small class="rd-flight-detail" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">
                            ({{ this.pdtTransInfo1.rmobileCode }}{{ this.pdtTransInfo1.rtTpcode }},&nbsp;{{ this.pdtTransInfo1.r_dpTime }} → {{ this.pdtTransInfo1.r_arTime }})
                          </small>
                        </span>
                      </div>
                    </div>

                    <!-- 신규예약 옵션 -->
                    <div v-if="this.newResFlag == 'Y'" class="rd-option-section">
                      <div class="rd-option-box">
                        <p class="rd-section-sub-title"><i class="bi bi-card-checklist"></i> 상품옵션</p>
                        <div v-if="this.selOptInfo.length <= 0" class="rd-empty-text">선택된 옵션이 없습니다.</div>
                        <div v-else>
                          <div :key="i" v-for="(so, i) in this.selOptInfo" class="rd-option-item">
                            <span class="rd-option-name">{{ so.optName }}</span>
                            <span class="rd-option-qty">{{ so.qty_opt }}개</span>
                            <span class="rd-option-price text-danger fw-bold">{{ this.getCurrencyFormat(so.optPrice * so.qty_opt) }}원</span>
                          </div>
                        </div>
                      </div>
                      <div class="rd-option-box" v-if="this.dirOptInfo.length > 0">
                        <p class="rd-section-sub-title"><i class="bi bi-pencil-square"></i> 직접입력 옵션</p>
                        <div :key="j" v-for="(dio, j) in this.dirOptInfo" class="rd-option-item">
                          <span class="rd-option-name">{{ dio.odName }}</span>
                          <span class="rd-option-price text-primary fw-bold">{{ dio.odValue }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- 구형 예약 옵션 -->
                    <div v-else class="rd-option-section">
                      <div class="rd-option-box">
                        <p class="rd-section-sub-title"><i class="bi bi-card-checklist"></i> 선택옵션</p>
                        <div>{{ optName }}</div>
                      </div>
                      <div class="rd-option-box">
                        <p class="rd-section-sub-title"><i class="bi bi-bag-plus"></i> 선택추가상품</p>
                        <div v-if="this.selAddPdt.length <= 0" class="rd-empty-text">선택된 추가상품이 없습니다.</div>
                        <div v-else :key="i" v-for="(ea, i) in this.selAddPdt" class="rd-option-item">
                          <span class="rd-option-name">{{ ea.addPdtName }}</span>
                          <span class="rd-option-qty">{{ ea.qty_addPdt }}개</span>
                        </div>
                      </div>
                    </div>

                    <!-- 추가상품 (신규) -->
                    <div v-if="this.newResFlag == 'Y' && this.addPdtFlag === 'Y'" class="rd-option-section">
                      <div class="rd-option-box rd-option-box--full">
                        <p class="rd-section-sub-title"><i class="bi bi-plus-circle"></i> 추가상품</p>
                        <div v-if="this.addPdtInfo.length <= 0" class="rd-empty-text">구매하신 추가상품이 없습니다.</div>
                        <div v-else>
                          <div :key="i" v-for="(so, i) in this.addPdtInfo" class="rd-option-item">
                            <span class="rd-option-name">{{ so.addPdtName }} ▶ {{ so.addPdtValue }}</span>
                            <span class="rd-option-qty">{{ so.addQty }}개</span>
                            <span class="rd-option-price text-danger fw-bold">{{ this.getCurrencyFormat(so.addPrice * so.addQty) }}원</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 모바일 -->
                  <div class="mobile">
                    <div class="rd-info-list">
                      <div class="rd-info-row" v-if="productInfo.salesRoute === 'F'">
                        <span class="rd-info-label">출발일자</span>
                        <span class="rd-info-value">{{ this.reserveInfo.reqDptDate }}</span>
                      </div>
                      <div class="rd-info-row" v-else>
                        <span class="rd-info-label">여행기간</span>
                        <span class="rd-info-value" v-if="!this.reserveInfo.reqDptDate || this.reserveInfo.reqDptDate == 'Invalid date'">-</span>
                        <span class="rd-info-value" v-else>{{ this.reserveInfo.reqDptDate }} ~ {{ this.reserveInfo.reqRtnDate }}</span>
                      </div>
                      <div class="rd-info-row">
                        <span class="rd-info-label">예약일</span>
                        <span class="rd-info-value">{{ this.reserveInfo.reqDate }}</span>
                      </div>
                      <div class="rd-info-row">
                        <span class="rd-info-label">여행지역</span>
                        <span class="rd-info-value">{{ this.productInfo.ntName }} / {{ this.productInfo.arName }}</span>
                      </div>
                      <div class="rd-info-row rd-info-row--col">
                        <span class="rd-info-label">예약상태</span>
                        <div class="rd-status-wrap">
                          <span class="rd-status-badge rd-status--paid" v-if="this.payStyle === 'f' && (this.reserveInfo.reqStatus != 'CO' && this.reserveInfo.reqStatus != 'CX')">전액결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--partial" v-else-if="this.payStyle === 'p' && (this.reserveInfo.reqStatus != 'CO' && this.reserveInfo.reqStatus != 'CX')">부분결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag == 'Y'">결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--request" v-else-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag != 'Y'">결제요청</span>
                          <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.reqStatus === 'PY' && (this.reserveInfo.cstPrice_new === this.reserveInfo.firstPayment || this.reserveInfo.firstPayment == null)">결제완료 (담당매니저 확인 중)</span>
                          <span class="rd-status-badge rd-status--cancel" v-else-if="this.reserveInfo.reqStatus === 'CX'"><s>{{ this.reserveInfo.procName }}</s></span>
                          <span class="rd-status-text" v-else>{{ this.reserveInfo.procName }}</span>
                        </div>
                      </div>
                      <div class="rd-info-row">
                        <span class="rd-info-label">출발 → 도착</span>
                        <span class="rd-info-value" v-if="productInfo.salesRoute == 'T'">한국 {{ this.pdtTransInfo1.ddCodeName }} → {{ this.productInfo.ntName }} {{ this.pdtTransInfo1.daCodeName }}</span>
                        <span class="rd-info-value" v-else-if="productInfo.salesRoute == 'F'">한국 {{ this.pdtTransInfo1.ddCodeName }} → {{ this.productInfo.ntName }} {{ this.pdtTransInfo1.daCodeName }}</span>
                        <span class="rd-info-value" v-else-if="productInfo.salesRoute == 'L' || productInfo.salesRoute == 'E'">현지일정</span>
                        <span class="rd-info-value" v-else>-</span>
                      </div>
                      <div class="rd-info-row">
                        <span class="rd-info-label">출발편</span>
                        <span class="rd-info-value">{{ this.pdtTransInfo1.dmobileCodeName }}<br>
                          <small class="rd-flight-detail" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">({{ this.pdtTransInfo1.dmobileCode }}{{ this.pdtTransInfo1.dpTpCode }},&nbsp;{{ this.pdtTransInfo1.d_dpTime }} → {{ this.pdtTransInfo1.d_arTime }})</small>
                        </span>
                      </div>
                      <div class="rd-info-row">
                        <span class="rd-info-label">귀국 → 도착</span>
                        <span class="rd-info-value" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">{{ this.productInfo.ntName }} {{ this.pdtTransInfo1.rdCodeName }} → 한국 {{ this.pdtTransInfo1.raCodeName }}</span>
                        <span class="rd-info-value" v-else-if="productInfo.salesRoute == 'L' || productInfo.salesRoute == 'E'">현지일정</span>
                        <span class="rd-info-value" v-else>-</span>
                      </div>
                      <div class="rd-info-row">
                        <span class="rd-info-label" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">귀국편</span>
                        <span class="rd-info-label" v-else>리턴편</span>
                        <span class="rd-info-value">{{ this.pdtTransInfo1.rmobileCodeName }}
                          <small class="rd-flight-detail" v-if="productInfo.salesRoute == 'T'">({{ this.pdtTransInfo1.rmobileCode }}{{ this.pdtTransInfo1.rtTpcode }},&nbsp;{{ this.pdtTransInfo1.r_dpTime }} → {{ this.pdtTransInfo1.r_arTime }})</small>
                        </span>
                      </div>
                      <div class="rd-info-row rd-info-row--col" v-if="this.newResFlag == 'Y'">
                        <span class="rd-info-label">상품옵션</span>
                        <div v-if="this.selOptInfo.length <= 0" class="rd-empty-text">선택된 옵션이 없습니다.</div>
                        <div v-else>
                          <div :key="i" v-for="(so, i) in this.selOptInfo" class="rd-option-item-mo">
                            - {{ so.optName }} ({{ so.qty_opt }}개, <span class="text-danger fw-bold">{{ this.getCurrencyFormat(so.optPrice * so.qty_opt) }}</span>원)
                          </div>
                        </div>
                        <div v-if="this.dirOptInfo.length > 0">
                          <div :key="j" v-for="(dio, j) in this.dirOptInfo" class="rd-option-item-mo">
                            - {{ dio.odName }}: <span class="text-primary fw-bold">{{ dio.odValue }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="rd-info-row rd-info-row--col" v-else>
                        <span class="rd-info-label">선택옵션</span>
                        <span class="rd-info-value">{{ optName }}</span>
                      </div>
                      <div v-if="this.newResFlag == 'Y' && this.addPdtFlag === 'Y'" class="rd-info-row rd-info-row--col">
                        <span class="rd-info-label">추가상품</span>
                        <div v-if="this.addPdtInfo.length <= 0" class="rd-empty-text">선택된 추가상품이 없습니다.</div>
                        <div v-else>
                          <div :key="i" v-for="(so, i) in this.addPdtInfo" class="rd-option-item-mo">
                            {{ so.addPdtName }} ▶ {{ so.addPdtValue }} ({{ so.addQty }}개, <span class="text-danger fw-bold">{{ this.getCurrencyFormat(so.addPrice * so.addQty) }}</span>원)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <!-- 예약자 정보 (기존) -->
              <div class="rd-card" v-if="ctCode !== 'H'">
                <div class="rd-card-header">
                  <i class="bi bi-person-circle"></i>
                  <span>예약자 정보</span>
                  <span v-if="reserveInfo.memLevel =='P'" class="rd-mem-badge rd-mem--premium"><i class="bi bi-award-fill"></i> 프리미엄 멤버십</span>
                  <span v-if="reserveInfo.memLevel =='S'" class="rd-mem-badge rd-mem--standard"><i class="bi bi-award"></i> 스탠다드 멤버십</span>
                </div>

                <!-- 엔버스 -->
                <div v-if="ctCode === 'N'" class="rd-card-body">
                  <div class="pc">
                    <div class="rd-info-grid">
                      <div class="rd-info-item">
                        <span class="rd-info-label">성명</span>
                        <span class="rd-info-value">{{ this.reserveInfo.inqName }}</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">연락처</span>
                        <span class="rd-info-value">{{ this.reserveInfo.inqTel }}</span>
                      </div>
                      <div class="rd-info-item rd-info-item--full">
                        <span class="rd-info-label">문의사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.etcInquiry" readonly></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="mobile">
                    <div class="rd-info-list">
                      <div class="rd-info-row"><span class="rd-info-label">성명</span><span class="rd-info-value">{{ this.reserveInfo.inqName }}</span></div>
                      <div class="rd-info-row"><span class="rd-info-label">연락처</span><span class="rd-info-value">{{ this.reserveInfo.inqTel }}</span></div>
                      <div class="rd-info-row rd-info-row--col">
                        <span class="rd-info-label">문의사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.etcInquiry" readonly></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 일반 -->
                <div v-else class="rd-card-body">
                  <div class="pc">
                    <div class="rd-info-grid">
                      <div class="rd-info-item">
                        <span class="rd-info-label">이름</span>
                        <span class="rd-info-value">{{ this.reserveInfo.reqName }}</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">연락처</span>
                        <span class="rd-info-value">{{ this.reserveInfo.reqTelNo }}</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">이메일</span>
                        <span class="rd-info-value">{{ this.email }}</span>
                      </div>
                      <div class="rd-info-item rd-info-item--full">
                        <span class="rd-info-label">문의사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.reqRemarks" maxlength="200" readonly></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="mobile">
                    <div class="rd-info-list">
                      <div class="rd-info-row"><span class="rd-info-label">이름</span><span class="rd-info-value">{{ this.reserveInfo.reqName }}</span></div>
                      <div class="rd-info-row"><span class="rd-info-label">연락처</span><span class="rd-info-value">{{ this.reserveInfo.reqTelNo }}</span></div>
                      <div class="rd-info-row"><span class="rd-info-label">이메일</span><span class="rd-info-value">{{ this.email }}</span></div>
                      <div class="rd-info-row">
                        <span class="rd-info-label">여행인원</span>
                        <span class="rd-info-value">{{ this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1 }}명</span>
                      </div>
                      <div class="rd-info-row rd-info-row--col">
                        <span class="rd-info-label">문의사항</span>
                        <textarea class="rd-textarea" v-model="reserveInfo.reqRemarks" maxlength="200" readonly></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <!-- 대표 여행자 정보 (기존) -->
              <div class="rd-card" v-if="ctCode !== 'H' && this.reserveInfo.myselfFlag === 'N'">
                <div class="rd-card-header">
                  <i class="bi bi-people"></i>
                  <span>대표 여행자 정보</span>
                </div>
                <div class="rd-card-body">
                  <div class="pc">
                    <div class="rd-info-grid">
                      <div class="rd-info-item"><span class="rd-info-label">이름</span><span class="rd-info-value">{{ this.reserveInfo.tripName }}</span></div>
                      <div class="rd-info-item"><span class="rd-info-label">연락처</span><span class="rd-info-value">{{ this.reserveInfo.tripCall }}</span></div>
                      <div class="rd-info-item"><span class="rd-info-label">이메일</span><span class="rd-info-value">{{ this.reserveInfo.tripEmail }}</span></div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">여행인원</span>
                        <span class="rd-info-value">{{ this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1 }}명</span>
                      </div>
                    </div>
                  </div>
                  <div class="mobile">
                    <div class="rd-info-list">
                      <div class="rd-info-row"><span class="rd-info-label">이름</span><span class="rd-info-value">{{ this.reserveInfo.tripName }}</span></div>
                      <div class="rd-info-row"><span class="rd-info-label">연락처</span><span class="rd-info-value">{{ this.reserveInfo.tripCall }}</span></div>
                      <div class="rd-info-row"><span class="rd-info-label">이메일</span><span class="rd-info-value">{{ this.reserveInfo.tripEmail }}</span></div>
                      <div class="rd-info-row">
                        <span class="rd-info-label">여행인원</span>
                        <span class="rd-info-value">{{ this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1 }}명</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <!-- 결제 정보 - 엔버스 (기존) -->
              <div class="rd-card" v-if="ctCode === 'N'">
                <div class="rd-card-header">
                  <i class="bi bi-credit-card"></i>
                  <span>결제 정보</span>
                </div>
                <div class="rd-card-body">
                  <div class="rd-pay-summary">
                    <div class="rd-pay-row">
                      <span class="rd-pay-label">할인금액</span>
                      <span class="rd-pay-value rd-pay-value--discount">- {{ this.getCurrencyFormat(sumPrice_dc) }}원</span>
                    </div>
                    <div class="rd-pay-row rd-pay-row--total">
                      <span class="rd-pay-label">총 결제금액</span>
                      <span class="rd-pay-value rd-pay-value--total">{{ this.getCurrencyFormat(this.nbusPriceTot) }}<em>원</em></span>
                    </div>
                  </div>

                  <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay <= 0">
                    <div class="rd-pay-history-item">
                      <span>결제액 ({{ this.rtnRPflag_tmp.fName }})</span>
                      <span>{{ getCurrencyFormat(this.rtnRPflag_tmp.actualPayAmount) }}원</span>
                    </div>
                  </div>
                  <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay > 0">
                    <p class="rd-pay-history-title">결제 내역</p>
                    <div class="rd-pay-history-item" v-if="fPayFlag === 'N' && p1PayAmt > 0">
                      <span><i class="bi bi-stop-fill text-warning"></i> 예약금결제</span>
                      <span>{{ getCurrencyFormat(p1PayAmt) }}원 <small v-if="p1PayDate != ''">({{ p1PayDate }})</small></span>
                    </div>
                    <div class="rd-pay-history-item" v-else-if="fPayFlag === 'Y' && p1PayAmt > 0">
                      <span><i class="bi bi-stop-fill text-warning"></i> 전액결제</span>
                      <span>{{ getCurrencyFormat(p1PayAmt) }}원 <small v-if="p1PayDate != ''">({{ p1PayDate }})</small></span>
                    </div>
                    <div class="rd-pay-history-item" v-if="payPointAmt != '' && payPointAmt > 0">
                      <span><i class="bi bi-stop-fill text-success"></i> 포인트결제</span>
                      <span>{{ getCurrencyFormat(payPointAmt) }}원 <small v-if="payPointDate != ''">({{ payPointDate }})</small></span>
                    </div>
                    <div class="rd-pay-history-item" v-if="p2PayAmt != '' && p2PayAmt > 0">
                      <span><i class="bi bi-stop-fill text-danger"></i> 잔여금결제</span>
                      <span>{{ getCurrencyFormat(p2PayAmt) }}원 <small v-if="p2PayDate != ''">({{ p2PayDate }})</small></span>
                    </div>
                  </div>

                  <div class="rd-pay-btn-wrap" v-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag != 'Y'">
                    <div v-if="this.reserveInfo.nbusPriceTot >= 200">
                      <button type="button" class="rd-pay-btn" @click="pgPay()"><i class="bi bi-shield-check"></i> 온라인결제</button>
                    </div>
                    <div v-else-if="this.reserveInfo.nbusPriceTot == 0">
                      <button type="button" class="rd-pay-btn rd-pay-btn--free" @click="freePay(this.reqRsvCode)"><i class="bi bi-gift"></i> 무료결제</button>
                    </div>
                    <div id="payment-method" v-show="showFlag" style="height:100%"></div>
                    <button @click="requestPayment(this.reqRsvCode)" class="rd-pay-btn" id="payment-button" v-show="showFlag" style="width:100%">
                      <b>결제하기</b>
                    </button>
                  </div>

                  <div class="rd-bank-info">
                    <p class="rd-bank-title"><i class="bi bi-exclamation-triangle-fill text-danger"></i> 계좌이체 안내</p>
                    <p class="rd-bank-text">결제금액이 <b>200원 미만</b> 또는 온라인 결제가 어려운 경우 아래 계좌로 송금하실 수 있습니다.</p>
                    <p class="rd-bank-account"><i class="bi bi-bank2"></i> 우리은행 1006-901-267484 &nbsp;예금주: 엔타비글로벌</p>
                    <p class="rd-bank-sub">송금 후 <b>1660-4602</b> 또는 <b>카카오톡</b>으로 연락을 주시면 빠른 확인이 가능합니다</p>
                    <p class="rd-bank-sub">※ 엔타비글로벌은 엔타비글로벌 법인명의계좌 이외로는 송금받지 않습니다</p>
                  </div>
                </div>
              </div>


              <!-- 결제 정보 - 일반 (기존) -->
              <div class="rd-card" v-if="ctCode !== 'H' && ctCode !== 'N'">
                <div class="rd-card-header">
                  <i class="bi bi-credit-card"></i>
                  <span>결제 정보</span>
                </div>
                <div class="rd-card-body">
                  <div class="pc">
                    <div class="rd-pay-detail-grid">
                      <div class="rd-pay-detail-left">
                        <div v-if="this.newResFlag === 'Y'">
                          <div v-if="this.selOptInfo.length > 0">
                            <div :key="i" v-for="(so, i) in this.selOptInfo" class="rd-option-item">
                              <span class="rd-option-name">- {{ so.optName }}</span>
                              <span class="rd-option-qty">{{ so.qty_opt }}개</span>
                              <span class="rd-option-price text-danger fw-bold">{{ this.getCurrencyFormat(so.optPrice * so.qty_opt) }}원</span>
                            </div>
                          </div>
                          <div class="mt-2" v-if="this.addPdtFlag === 'Y'">
                            <div :key="i" v-for="(so, i) in this.addPdtInfo" class="rd-option-item">
                              <span class="rd-option-name">- {{ so.addPdtName }} ▶ {{ so.addPdtValue }}</span>
                              <span class="rd-option-qty">{{ so.addQty }}개</span>
                              <span class="rd-option-price text-danger fw-bold">{{ this.getCurrencyFormat(so.addPrice * so.addQty) }}원</span>
                            </div>
                          </div>
                          <div class="mt-2" v-if="this.reserveInfo.memDCAmt > 0">
                            <span class="rd-option-name">- 멤버십 전용할인</span>
                            <span class="rd-option-price text-success fw-bold">-{{ this.getCurrencyFormat(this.reserveInfo.memDCAmt) }}원</span>
                          </div>
                        </div>
                        <div v-else>
                          <div class="rd-person-price">
                            <div v-if="this.reserveInfo.reqAdultCnt>0" class="rd-option-item">
                              <span class="rd-option-name">성인 {{ getCurrencyFormat(this.reserveInfo.reqAdultPrice) }}원</span>
                              <span class="rd-option-qty">× {{ this.reserveInfo.reqAdultCnt }}명</span>
                            </div>
                            <div v-if="this.reserveInfo.reqChildCnt>0" class="rd-option-item">
                              <span class="rd-option-name">소아 {{ getCurrencyFormat(this.reserveInfo.reqChildPrice) }}원</span>
                              <span class="rd-option-qty">× {{ this.reserveInfo.reqChildCnt }}명</span>
                            </div>
                            <div v-if="this.reserveInfo.reqInfCnt>0" class="rd-option-item">
                              <span class="rd-option-name">유아 {{ getCurrencyFormat(this.reserveInfo.reqInfPrice * this.reserveInfo.reqInfCnt) }}원</span>
                              <span class="rd-option-qty">× {{ this.reserveInfo.reqInfCnt }}명</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="rd-pay-detail-right">
                        <div class="rd-pay-summary">
                          <div class="rd-pay-row rd-pay-row--total">
                            <span class="rd-pay-label">총 결제금액</span>
                            <span class="rd-pay-value rd-pay-value--total">{{ this.getCurrencyFormat(this.reserveInfo.totalPrice) }}<em>원</em></span>
                          </div>
                        </div>

                        <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && this.totalPay <= 0">
                          <div class="rd-pay-history-item"><span>결제액 ({{ this.rtnRPflag_tmp.fName }})</span><span>{{ getCurrencyFormat(this.rtnRPflag_tmp.actualPayAmount) }}원</span></div>
                          <div class="rd-pay-history-item"><span>포인트결제</span><span>{{ getCurrencyFormat(this.payPointAmt) }}원</span></div>
                          <div class="rd-pay-history-item"><span>쿠폰결제</span><span>{{ getCurrencyFormat(this.payCouponAmt) }}원</span></div>
                        </div>

                        <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay > 0">
                          <p class="rd-pay-history-title">결제 내역</p>
                          <div class="rd-pay-history-item" v-if="fPayFlag === 'N' && p1PayAmt > 0">
                            <span><i class="bi bi-stop-fill text-warning"></i> 예약금결제</span>
                            <span>{{ getCurrencyFormat(p1PayAmt) }}원 <small v-if="p1PayDate != undefined">({{ p1PayDate }})</small></span>
                          </div>
                          <div class="rd-pay-history-item" v-else-if="fPayFlag === 'Y' && (p1PayAmt > 0)">
                            <span><i class="bi bi-stop-fill text-warning"></i> 전액결제</span>
                            <span>{{ getCurrencyFormat(p1PayAmt) }}원 <small v-if="p1PayDate != undefined">({{ p1PayDate }})</small></span>
                          </div>
                          <div v-if="fPayFlag === 'Y'">
                            <div class="rd-pay-history-item" v-if="payPointAmt != undefined && payPointAmt > 0">
                              <span><i class="bi bi-stop-fill text-warning"></i> 포인트결제</span>
                              <span>{{ getCurrencyFormat(payPointAmt) }}원 <small v-if="payPointDate != undefined">({{ payPointDate }})</small></span>
                            </div>
                            <div class="rd-pay-history-item" v-if="payCouponAmt != undefined && payCouponAmt > 0">
                              <span><i class="bi bi-stop-fill text-warning"></i> 쿠폰결제</span>
                              <span>{{ getCurrencyFormat(payCouponAmt) }}원 <small v-if="payCouponDate != undefined">({{ payCouponDate }})</small></span>
                            </div>
                          </div>
                          <div v-else>
                            <div class="rd-pay-history-item" v-if="payPointAmt != undefined && payPointAmt > 0">
                              <span><i class="bi bi-stop-fill text-success"></i> 예약금 포인트결제</span>
                              <span>{{ getCurrencyFormat(payPointAmt) }}원 <small v-if="payPointDate != undefined">({{ payPointDate }})</small></span>
                            </div>
                            <div class="rd-pay-history-item" v-if="payCouponAmt != undefined && payCouponAmt > 0">
                              <span><i class="bi bi-stop-fill text-success"></i> 예약금 쿠폰결제</span>
                              <span>{{ getCurrencyFormat(payCouponAmt) }}원 <small v-if="payCouponDate != undefined">({{ payCouponDate }})</small></span>
                            </div>
                          </div>
                          <div class="rd-pay-history-item" v-if="p2PayAmt != '' && p2PayAmt > 0">
                            <span><i class="bi bi-stop-fill text-danger"></i> 잔여금결제</span>
                            <span>{{ getCurrencyFormat(p2PayAmt) }}원 <small v-if="p2PayDate != undefined">({{ p2PayDate }})</small></span>
                          </div>
                          <div class="rd-pay-history-item" v-if="payPointAmt2 != undefined && payPointAmt2 > 0">
                            <span><i class="bi bi-stop-fill text-success"></i> 잔여금 포인트결제</span>
                            <span>{{ getCurrencyFormat(payPointAmt2) }}원 <small v-if="payPointDate2 != undefined">({{ payPointDate2 }})</small></span>
                          </div>
                          <div class="rd-pay-history-item" v-if="payCouponAmt2 != undefined && payCouponAmt2 > 0">
                            <span><i class="bi bi-stop-fill text-success"></i> 잔여금 쿠폰결제</span>
                            <span>{{ getCurrencyFormat(payCouponAmt2) }}원 <small v-if="payCouponDate2 != undefined">({{ payCouponDate2 }})</small></span>
                          </div>
                          <div class="rd-pay-history-item" v-if="this.reserveInfo.memDCAmt > 0">
                            <span><i class="bi bi-stop-fill text-info"></i> 멤버십 전용할인</span>
                            <span>{{ getCurrencyFormat(this.reserveInfo.memDCAmt) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="rd-mem-benefit-row" v-if="(reserveInfo.memLevel === 'P' || reserveInfo.memLevel === 'S') && (reserveInfo.dispFlag === 'c2' || reserveInfo.dispFlag === 'c4' || reserveInfo.dispFlag === 'c5')">
                      <div class="rd-mem-benefit-label">
                        <span v-if="reserveInfo.memLevel === 'P'" class="rd-mem--premium"><i class="bi bi-award-fill"></i> 프리미엄멤버십 할인액 <small>(선택옵션 할인포함)</small></span>
                        <span v-if="reserveInfo.memLevel === 'S'" class="rd-mem--standard"><i class="bi bi-award"></i> 스탠다드멤버십 할인액 <small>(선택옵션 할인포함)</small></span>
                        <p class="rd-mem-note"><i class="bi bi-info-circle"></i> 환급 또는 환불은 선택된 결제수단으로 진행됩니다</p>
                      </div>
                      <div class="rd-mem-benefit-value">
                        <span v-if="reserveInfo.memLevel === 'P'" class="rd-mem--premium">{{ this.getCurrencyFormat(this.totRefundAmt + this.selOPtPriceDCTot_self) }}원</span>
                        <span v-if="reserveInfo.memLevel === 'S'" class="rd-mem--standard">{{ this.getCurrencyFormat(this.totRefundAmt + this.selOPtPriceDCTot_self) }}원</span>
                      </div>
                    </div>
                    <div class="rd-mem-benefit-row" v-if="reserveInfo.tot_comDC > 0">
                      <div class="rd-mem-benefit-label">
                        <span><i class="bi bi-people"></i> 멤버십 동반자할인액</span>
                        <p class="rd-mem-note"><i class="bi bi-info-circle"></i> 환급 또는 환불은 선택된 결제수단으로 진행됩니다</p>
                      </div>
                      <div class="rd-mem-benefit-value">{{ this.getCurrencyFormat(this.reserveInfo.tot_comDC + this.selOPtPriceDCTot_exSelf) }}원</div>
                    </div>
                    <div class="rd-mem-benefit-row" v-if="(reserveInfo.memLevel === 'P' || reserveInfo.memLevel === 'S') && (reserveInfo.dispFlag === 'c1' || reserveInfo.dispFlag === 'c3')">
                      <div class="rd-mem-benefit-label">
                        <span v-if="reserveInfo.memLevel === 'P'" class="rd-mem--premium"><i class="bi bi-award-fill"></i> 프리미엄멤버십 환급액</span>
                        <span v-if="reserveInfo.memLevel === 'S'" class="rd-mem--standard"><i class="bi bi-award"></i> 스탠다드멤버십 환급액</span>
                        <p class="rd-mem-note"><i class="bi bi-info-circle"></i> 환급 또는 환불은 선택된 결제수단으로 진행됩니다</p>
                      </div>
                      <div class="rd-mem-benefit-value">
                        <span v-if="reserveInfo.memLevel === 'P'" class="rd-mem--premium">{{ this.getCurrencyFormat(this.totRefundAmt + selOptPriceRef_tot) }}원</span>
                        <span v-if="reserveInfo.memLevel === 'S'" class="rd-mem--standard">{{ this.getCurrencyFormat(this.totRefundAmt + selOptPriceRef_tot) }}원</span>
                      </div>
                    </div>
                  </div>

                  <!-- 모바일 -->
                  <div class="mobile">
                    <div class="rd-info-list">
                      <div class="rd-info-row">
                        <span class="rd-info-label">특별할인금액</span>
                        <span class="rd-info-value text-primary" v-if="this.reserveInfo.optDcPrice > 0">{{ this.getCurrencyFormat(this.reserveInfo.optDcPrice) }}원</span>
                        <span class="rd-info-value" v-else>-</span>
                      </div>
                      <div class="rd-pay-row rd-pay-row--total" style="padding:1rem 0">
                        <span class="rd-pay-label">총 결제금액</span>
                        <span class="rd-pay-value rd-pay-value--total">{{ this.getCurrencyFormat(this.reserveInfo.totalPrice) }}<em>원</em></span>
                      </div>
                    </div>

                    <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && this.totalPay <= 0">
                      <div class="rd-pay-history-item"><span>결제액 ({{ this.rtnRPflag_tmp.fName }})</span><span>{{ getCurrencyFormat(this.rtnRPflag_tmp.actualPayAmount) }}원</span></div>
                      <div class="rd-pay-history-item"><span>포인트결제</span><span>{{ getCurrencyFormat(this.payPointAmt) }}원</span></div>
                      <div class="rd-pay-history-item"><span>쿠폰결제</span><span>{{ getCurrencyFormat(this.payCouponAmt) }}원</span></div>
                      <div class="rd-pay-history-item" v-if="this.reserveInfo.memDCAmt > 0"><span>멤버십 전용할인</span><span>{{ getCurrencyFormat(this.reserveInfo.memDCAmt) }}</span></div>
                    </div>
                    <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay > 0">
                      <p class="rd-pay-history-title">결제 내역</p>
                      <div class="rd-pay-history-item" v-if="fPayFlag === 'N' && p1PayAmt > 0">
                        <span><i class="bi bi-stop-fill text-warning"></i> 예약금결제</span>
                        <span>{{ getCurrencyFormat(p1PayAmt) }}원<br><small v-if="p1PayDate != undefined">({{ p1PayDate }})</small></span>
                      </div>
                      <div class="rd-pay-history-item" v-else-if="fPayFlag === 'Y' && (p1PayAmt > 0)">
                        <span><i class="bi bi-stop-fill text-warning"></i> 전액결제</span>
                        <span>{{ getCurrencyFormat(p1PayAmt) }}원<br><small v-if="p1PayDate != undefined">({{ p1PayDate }})</small></span>
                      </div>
                      <div v-if="fPayFlag === 'Y'">
                        <div class="rd-pay-history-item" v-if="payPointAmt != undefined && payPointAmt > 0">
                          <span><i class="bi bi-stop-fill text-warning"></i> 포인트결제</span>
                          <span>{{ getCurrencyFormat(payPointAmt) }}원<br><small v-if="payPointDate != undefined">({{ payPointDate }})</small></span>
                        </div>
                        <div class="rd-pay-history-item" v-if="payCouponAmt != undefined && payCouponAmt > 0">
                          <span><i class="bi bi-stop-fill text-warning"></i> 쿠폰결제</span>
                          <span>{{ getCurrencyFormat(payCouponAmt) }}원<br><small v-if="payCouponDate != undefined">({{ payCouponDate }})</small></span>
                        </div>
                      </div>
                      <div v-else>
                        <div class="rd-pay-history-item" v-if="payPointAmt != undefined && payPointAmt > 0">
                          <span><i class="bi bi-stop-fill text-success"></i> 예약금 포인트결제</span>
                          <span>{{ getCurrencyFormat(payPointAmt) }}원<br><small v-if="payPointDate != undefined">({{ payPointDate }})</small></span>
                        </div>
                        <div class="rd-pay-history-item" v-if="payCouponAmt != undefined && payCouponAmt > 0">
                          <span><i class="bi bi-stop-fill text-success"></i> 예약금 쿠폰결제</span>
                          <span>{{ getCurrencyFormat(payCouponAmt) }}원<br><small v-if="payCouponDate != undefined">({{ payCouponDate }})</small></span>
                        </div>
                      </div>
                      <div class="rd-pay-history-item" v-if="p2PayAmt != '' && p2PayAmt > 0">
                        <span><i class="bi bi-stop-fill text-danger"></i> 잔여금결제</span>
                        <span>{{ getCurrencyFormat(p2PayAmt) }}원<br><small v-if="p2PayDate != undefined">({{ p2PayDate }})</small></span>
                      </div>
                      <div class="rd-pay-history-item" v-if="payPointAmt2 != undefined && payPointAmt2 > 0">
                        <span><i class="bi bi-stop-fill text-success"></i> 잔여금 포인트결제</span>
                        <span>{{ getCurrencyFormat(payPointAmt2) }}원<br><small v-if="payPointDate2 != undefined">({{ payPointDate2 }})</small></span>
                      </div>
                      <div class="rd-pay-history-item" v-if="payCouponAmt2 != undefined && payCouponAmt2 > 0">
                        <span><i class="bi bi-stop-fill text-success"></i> 잔여금 쿠폰결제</span>
                        <span>{{ getCurrencyFormat(payCouponAmt2) }}원<br><small v-if="payCouponDate2 != undefined">({{ payCouponDate2 }})</small></span>
                      </div>
                      <div class="rd-pay-history-item" v-if="this.reserveInfo.memDCAmt > 0">
                        <span><i class="bi bi-stop-fill text-info"></i> 멤버십 전용할인</span>
                        <span>{{ getCurrencyFormat(this.reserveInfo.memDCAmt) }}</span>
                      </div>
                    </div>

                    <div class="rd-mem-benefit-row" v-if="(reserveInfo.memLevel === 'P' || reserveInfo.memLevel === 'S') && (reserveInfo.dispFlag === 'c1' || reserveInfo.dispFlag === 'c3')">
                      <div class="rd-mem-benefit-label">
                        <span v-if="reserveInfo.memLevel === 'P'" class="rd-mem--premium">프리미엄환급액</span>
                        <span v-else-if="reserveInfo.memLevel === 'S'" class="rd-mem--standard">스탠다드환급액</span>
                        <p class="rd-mem-note">환급 또는 환불은 선택된 결제수단으로 진행됩니다</p>
                      </div>
                      <div class="rd-mem-benefit-value">
                        <span v-if="reserveInfo.memLevel === 'P'" class="rd-mem--premium">{{ this.getCurrencyFormat(this.totRefundAmt + selOptPriceRef_tot) }}원</span>
                        <span v-else-if="reserveInfo.memLevel === 'S'" class="rd-mem--standard">{{ this.getCurrencyFormat(this.totRefundAmt + selOptPriceRef_tot) }}원</span>
                      </div>
                    </div>
                    <div class="rd-mem-benefit-row" v-if="(reserveInfo.memLevel === 'P' || reserveInfo.memLevel === 'S') && (reserveInfo.dispFlag === 'c2' || reserveInfo.dispFlag === 'c4' || reserveInfo.dispFlag === 'c5')">
                      <div class="rd-mem-benefit-label">
                        <span v-if="reserveInfo.memLevel === 'P'" class="rd-mem--premium">프리미엄할인액 <small>(옵션할인포함)</small></span>
                        <span v-else-if="reserveInfo.memLevel === 'S'" class="rd-mem--standard">스탠다드할인액 <small>(옵션할인포함)</small></span>
                      </div>
                      <div class="rd-mem-benefit-value">
                        <span v-if="reserveInfo.memLevel === 'P'" class="rd-mem--premium">{{ this.getCurrencyFormat(this.totRefundAmt + this.selOPtPriceDCTot_self) }}원</span>
                        <span v-if="reserveInfo.memLevel === 'S'" class="rd-mem--standard">{{ this.getCurrencyFormat(this.totRefundAmt + this.selOPtPriceDCTot_self) }}원</span>
                      </div>
                    </div>
                    <div class="rd-mem-benefit-row" v-if="reserveInfo.tot_comDC > 0">
                      <div class="rd-mem-benefit-label">멤버십 동반자할인액</div>
                      <div class="rd-mem-benefit-value">{{ getCurrencyFormat(this.reserveInfo.tot_comDC + this.selOPtPriceDCTot_exSelf) }}원</div>
                    </div>
                  </div>

                  <!-- 결제 버튼 -->
                  <div class="rd-pay-btn-wrap" v-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag != 'Y'">
                    <div v-if="this.reserveInfo.cstPrice_new >= 200">
                      <button type="button" class="rd-pay-btn" @click="pgPay()"><i class="bi bi-shield-check"></i> 온라인결제</button>
                    </div>
                    <div v-else-if="this.reserveInfo.cstPrice_new == 0">
                      <button type="button" class="rd-pay-btn rd-pay-btn--free" @click="freePay(this.reqRsvCode)"><i class="bi bi-gift"></i> 무료결제</button>
                    </div>
                    <div id="payment-method" v-show="showFlag" style="height:100%"></div>
                    <button @click="requestPayment(this.reqRsvCode)" class="rd-pay-btn" id="payment-button" v-show="showFlag" style="width:100%"><b>결제하기</b></button>
                  </div>

                  <!-- 잔액결제 버튼 -->
                  <div class="rd-pay-btn-wrap" v-if="this.rtnRPflag_tmp.reqPayBalance === 'Y'">
                    <div v-if="this.balance >= 0">
                      <button type="button" class="rd-pay-btn rd-pay-btn--balance" @click="pgPay('p2')">
                        <i class="bi bi-shield-check"></i> 온라인 잔액결제 ({{ this.getCurrencyFormat(this.balance) }}원)
                      </button>
                    </div>
                    <div v-else-if="this.reserveInfo.cstPrice_new == 0">
                      <button type="button" class="rd-pay-btn rd-pay-btn--free" @click="freePay(this.reqRsvCode, 'p2')"><i class="bi bi-gift"></i> 무료잔액결제</button>
                    </div>
                    <div id="payment-method" v-show="showFlag" style="height:100%"></div>
                    <button @click="requestPayment(this.reqRsvCode, 'p2')" class="rd-pay-btn" id="payment-button" v-show="showFlag" style="width:100%"><b>잔액결제</b></button>
                  </div>

                  <!-- 계좌 안내 -->
                  <div class="rd-bank-info">
                    <p class="rd-bank-title"><i class="bi bi-exclamation-triangle-fill text-danger"></i> 계좌이체 안내</p>
                    <p class="rd-bank-text">결제금액이 <b>200원 미만</b> 또는 온라인 결제가 어려운 경우 아래 계좌로 송금하실 수 있습니다.</p>
                    <p class="rd-bank-account"><i class="bi bi-bank2"></i> 우리은행 1006-901-267484 &nbsp;예금주: 엔타비글로벌</p>
                    <p class="rd-bank-sub">송금 후 <b>1660-4602</b> 또는 <b>카카오톡</b>으로 연락을 주시면 빠른 확인이 가능합니다</p>
                    <p class="rd-bank-sub">※ 엔타비글로벌은 엔타비글로벌 법인명의계좌 이외로는 송금받지 않습니다</p>
                  </div>
                </div>
              </div>


              <!-- 하단 버튼 (기존 - 호텔 제외) -->
              <div class="rd-footer-btns" v-if="ctCode !== 'H'">
                <button type="button" class="rd-footer-btn rd-footer-btn--main" @click="goToMypage()">
                  <i class="bi bi-house"></i> 마이페이지로
                </button>

                <div v-if="reserveInfo.reqStatus != 'CX'">
                  <div v-if="ctCode==='N'">
                    <button type="button" class="rd-footer-btn rd-footer-btn--cancel" @click="reqCxl_nbus(this.reserveInfo.inqCode)" v-if="res_checkReqCxl.length <= 0">
                      <i class="bi bi-x-circle"></i> 취소요청하기
                    </button>
                    <button type="button" class="rd-footer-btn rd-footer-btn--cancel" disabled v-else>
                      <i class="bi bi-hourglass-split"></i> 취소요청 중
                    </button>
                  </div>
                  <div v-else>
                    <button type="button" class="rd-footer-btn rd-footer-btn--cancel" @click="reqCxl(this.reqRsvCode, this.productInfo.pdtCode)" v-if="res_checkReqCxl.length <= 0">
                      <i class="bi bi-x-circle"></i> 취소요청하기
                    </button>
                    <button type="button" class="rd-footer-btn rd-footer-btn--cancel" disabled v-else>
                      <i class="bi bi-hourglass-split"></i> 취소요청 중
                    </button>
                  </div>
                </div>
                <div v-else-if="reserveInfo.reqStatus == 'CX'">
                  <button type="button" class="rd-footer-btn rd-footer-btn--cancel" disabled>
                    <i class="bi bi-check-circle"></i> 취소완료
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { loadPaymentWidget, ANONYMOUS } from "@tosspayments/payment-widget-sdk";
import axios from 'axios';
// import { getAvailPoint } from '../assets/js/commonFunctions.js';
import { handlerInfo } from '../assets/js/commonFunctions'
//import moment from 'moment';

export default {
  // components: {
  //   DatePicker
  // },
  data() {
    return {
      showFlag: false,        //결제창 표시여부

      //토스페이결제용
      paymentWidget: null,
      paymentMethodWidget: null,
      //clientKey: "test_ck_YyZqmkKeP8gG2Klanln8bQRxB9lG",
      clientKey: "live_ck_jZ61JOxRQVEZXa1aoR0rW0X9bAqw",
      customerKey: "Ntabi-1936=@",

      productInfo: [],          //상품정보
      reserveInfo: [],          //예약정보
      selOptInfo: [],           //선택형옵션정보
      dirOptInfo: [],           //직접형옵션정보

      newResFlag: "",          //신규예약여부

      isReviewFlag: "",         //기존리뷰 존재여부
      aPromoFlag: "N",          //적용프로모션 존재여부
      //reserveInfo: [],          //예약정보
      reserveInfo_detail: [],   //예약디테일(금액정보)
      selEctOptList: [],        //예약된 선택옵션
      productCode: "",          //상품코드
      email: "",                //예약자이메일(원본 또는 수정)

      //userPayInfo: [],          //결제내역정보
      
      availPoint: 0,            //가용포인트

      paidPoint: 0,             //사용포인트
      payPointFlag: "N",        //포인트사용여부

      pointForPay: 0,           //결제에 사용할 포인트

      payByPointFlag: "N",      //포인트사용 플래그
      pointForPay_tmp: 0,       //포인트 복구용 직전 사용예정 포인트
      rtnRPflag_tmp: [],        //결제 후 포인트와 결제정보

      rtnRPflag: "N",           //결제요청여부
      paidFlag: "N",            //결제여부

      productTrans: [],
      pdtTransInfo1: [],        //기존교통정보
      pdtTransInfo: [],
      pdtPromoInfo: [],         //프로모션정보

      pdtFlag: "",              //상품종류

      productImage: [],         //상품이미지

      selectedProcCode: "",     //예약처리상태

      sRoute: [],               //상품구분

      reqMarginRate: 0,         //당해예약마진
      reqMarginMethod: "P",     //당해예약마진계산방법(P/A)

      productPromotion: [],
      choicePromotion: [],      //선택된 프로모션정보
      promoList: [],            //해당상품의 프로모션목록

      optFlag: "",              //옵션선택플래그

      pdtcode: "",

      productPrice: [],

      promoStart: "",
      promoEnd: "",

      res_checkReqCxl: [],    //취소요청여부

      totRefundAmt: 0,        //환급액전액

      // 구매된 옵션 & 추가상품
      selOptFlag: "N",              //선택옵션유무
      selAddFlag: "N",              //선택추상유무
      pdtOptInfo: [],               //상품선택옵션정보
      pdtOptFlag: "N",              //선택옵션유무
      calOptFlag: "N",              //선택옵션유무(예약용)
      selOptions: [],               //선택된 옵션정보
      tot_selOptPrice:  0,          //선택된 옵션총액
      selOptNames: [],              //선택옵션명

      //addPdtInfo: [],               //추가상품정보
      //addPdtFlag: "N",              //추가상품유무
      calAddFlag: "N",              //추가상품유무(예약용)
      selAddPdt: [],                //선택된 추가상품정보
      tot_selAddPdtPrice:  0,       //선택된 추상총액
      selAddPdtNames: [],           //선택추상명

      balance: 0,                   //잔여대금
      payStyle: "",                 //전액f, 부분p
      pPoint: 0,                    //결제하려는 포인트액

      /////결제히스토리용 정보
      userPayInfo: [],              //히스토리용 결제내역(향후 내역은 이 배열을 이용)
      p1PayAmt: 0, 
      p1PayDate: "",
      p2PayAmt: 0, 
      p2PayDate:"",
      payPointDate: "",
      payPointDate2: "",
      fPayFlag: "",                //예약금결제N, 전액결제Y
      totalPay: 0,                 //히스토리합산
      payPointAmt: 0,             //p1포인트결제액
      payPointAmt2: 0,            //p2포인트결제액

      payCouponDate: "",
      payCouponDate2: "",
      payCouponAmt: 0,             //p1쿠폰결제액
      payCouponAmt2: 0,            //p2쿠폰결제액


      optName: "",                //선택된 옵션명 
      selOptPriceTot: [],         //선택옵션별 총액
      selOPtPriceDCTot_self: 0,   //선택옵션 본인할인액
      selOPtPriceDCTot_exSelf: 0, //선택옵션 동반할인액(본인제외)
      selOptPriceRef_tot: 0,      //선택옵션 환급총액
      paymentInFull: "N",         //완납여부

      virAccInfo: [],             //가상계좌결제정보
      accPayStatus: "",           //가상계좌결제상태

      //엔버스 정보
      nbusInfo: [],               //엔버스 마스타정보
      exist_nbRoute: [],          //엔버스 경로정보   
      
      sumPrice_dc: 0,             //엔버스할인총액
      nbusPriceTot: 0,            //엔버스결제총액

      handTel: [],                //매니저연락처
      handTelCnt: 0,              //수신처갯수

      cxlFlag: "N",               //취소요청상태

      addPdtFlag: "N",              //추가상품여부
      addPdtInfo: [],               //추가상품정보

      // 호텔예약
      bookingNo:         '',
      hotelBookingInfo:  {},
      hotelBookingGuests: [],

      //호텔헤데
      hotelDetailInfo: {},

      hotelCancelLoading: false,   // 취소처리 중 버튼 비활성화용      
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    availableCoupons() {
      return this.userCouponInfo.filter(cp => cp.canPay === "Y")
    },

    // ✅ 취소정책 구조화 (cancellation_policies 파싱)
    cancelPolicyDetails() {
      const raw = this.hotelBookingInfo.cancel_policy
      if (!raw) return []

      let policy
      try 
      {
        policy = typeof raw === 'string' ? JSON.parse(raw) : raw
      } 
      catch (e) 
      {
        return []
      }

      const policies = policy.cancellation_policies || []
      if (policies.length === 0) return []

      const now = new Date()

      return policies.map(p => {
        const from = p.date_from ? new Date(p.date_from) : null
        const to   = p.date_to   ? new Date(p.date_to)   : null
        const percent = p.penalty_percentage || 0

        let percentText = ''
        let percentColor = '#16a34a'
        if (percent === 0) 
        {
          percentText = '무료취소'
          percentColor = '#16a34a'
        } 
        else if (percent >= 100) 
        {
          percentText = '환불불가 (100%)'
          percentColor = '#c62828'
        } 
        else 
        {
          percentText = `${percent}% 수수료`
          percentColor = '#b45309'
        }

        const isCurrent = !!(from && now >= from && (!to || now < to))

        return {
          // ✅ getKorDateFormat 재사용
          label: `${from ? this.getKorDateFormat(from) : '-'} ~ ${to ? this.getKorDateFormat(to) : '-'}`,
          percentText,
          percentColor,
          isCurrent
        }
      })
    },
  },

  // 생성 시, 상품카테고리 가져온다
  created() {
    this.reqRsvCode = this.$route.query.seqReq;
    this.productId = this.$route.query.pCode;
    this.ctCode = this.$route.query.cCode;                 //N:엔버스 H:호텔  Y:상품
    this.salesRoute = this.$route.query.salesRoute;
    this.ntCd = this.$route.query.ntCd;

    // ✅ 호텔예약
    if (this.ctCode === 'H') {
      this.bookingNo = this.$route.query.bookingNo;
      this.getHotelBookingDetail();
      return;
    }

    this.getReserInfo();

    if(this.ctCode === "Y")               //상품예약인 경우
    {
      this.getProductInfo();
      this.getProductImage();
    }

    this.getReqProcLevel()
  },
  mounted() {
    // if(document.referrer == "")
    // {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   location.replace("/")
    // }
    
    //비회원 접근 시 대응처리
    if(!this.$store.state.user.email || this.$store.state.user.email == undefined)
    {
      var swal = require('sweetalert2');
      swal.fire({
        title: '',
        text: '로그인 후 이용해주세요.',
        icon: 'warning'
      });
      this.$router.push({path: '/'});
    }

    this.getHandlerInfo()                 //알림톡 발송대상 체크

    // ctCode === 'H' 일 때만 맵 로드
    if (this.ctCode === 'H') 
    {
      this.$nextTick(() => {
        this.loadGoogleMaps_hotel()
      })
    }
  },
  methods: {
    //mixin함수
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    //한국표준시로 변경
    getKorDateFormat(date) {
      return this.$korDateFormat(date)
    },
    //원단위절사
    getTruncateToWon(value){
      return this.$truncateToWon(value)
    },

    // 호텔예약 구글맵 로드 및 초기화
    loadGoogleMaps_hotel() {
      if (window.google?.maps) {
        this.initMap_hotel()
        return
      }
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&language=ko`
      script.async = true
      script.defer = true
      script.onload = () => this.initMap_hotel()
      document.head.appendChild(script)
    },

    initMap_hotel() {
      // ✅ latitude/longitude 로 통일
      if (!this.hotelDetailInfo.latitude || !this.hotelDetailInfo.longitude) return

      const lat = parseFloat(this.hotelDetailInfo.latitude)
      const lng = parseFloat(this.hotelDetailInfo.longitude)

      const mapEl = document.getElementById('hotel-detail-map')
      if (!mapEl) return

      const map = new window.google.maps.Map(mapEl, {
        center: { lat, lng },
        zoom: 15,
        mapTypeControl:    false,
        streetViewControl: false,
        fullscreenControl: true,
      })

      new window.google.maps.Marker({
        position: { lat, lng },
        map,
        title: this.hotelBookingInfo.hotel_name,
        icon: { url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png' }
      })

      new window.google.maps.InfoWindow({
        content: `<div style="font-size:13px; font-weight:700; padding:4px 8px;">
          ${this.hotelBookingInfo.hotel_name}
        </div>`
      }).open(map)
    },

    // 호텔예약
    async getHotelBookingDetail() {
      // ✅ myHotelBookingList → hotelBookingDetail 로 변경
      const info = await this.$api('/api/hotelBookingDetail', {
        param: [this.bookingNo]
      });
      if (info && info.length > 0)
      {
        this.hotelBookingInfo = info[0];
        //console.log('[hotelBookingInfo]', this.hotelBookingInfo)  // 임시 확인용

        const detail = await this.$api('/api/hotelDetailForBooking', {
          param: [this.hotelBookingInfo.hotel_id]
        });
        if (detail && detail.length > 0)
        {
          this.hotelDetailInfo = detail[0];
          //console.log('[hotelDetailInfo]', this.hotelDetailInfo)  // 임시 확인용
          this.$nextTick(() => {
            this.loadGoogleMaps_hotel()
          })
        }
      }

      const guests = await this.$api('/api/hotelBookingGuests', {
        param: [this.bookingNo]
      });
      if (guests && guests.length > 0)
      {
        this.hotelBookingGuests = guests;
      }
    },

    hotelStatusText(status) {
      const map = {
        'bkg-ip': '처리중',
        'bkg-ps': '확인중',
        'bkg-cf': '예약확정',
        'bkg-cx': '취소',
        'bkg-af': '예약실패',
      };
      return map[status] || status;
    },

    hotelStatusClass(status) {
      const map = {
        'bkg-ip': 'status-h-wait',
        'bkg-ps': 'status-h-wait',
        'bkg-cf': 'status-h-done',
        'bkg-cx': 'status-h-cancel',
        'bkg-af': 'status-h-danger',
      };
      return map[status] || '';
    },

    /**
     * 호텔 예약 취소 프로세스 : 2026-06-11
      ① 취소 진입점: 수수료 조회 후 모달 안내 (수수료 없으면 바로 ②로)
      ② 실제 취소 실행: RTX + TOSS PAYMENTS API 연동
     */
    // ─── ① 취소 진입점 ───────────────────────────────────────────
    async reqCancelHotel() {
      // // cancel_remarks 없으면 요청만(담당자 확인) 케이스로
      // if (!this.hotelBookingInfo.cancel_remarks) {
      //   this.reqCxlHotelRequestOnly()
      //   return
      // }

      // 수수료 조회
      this.hotelCancelLoading = true
      let chargeInfo = null
      try 
      {
        const res = await axios.post('/api/hotel/getCancelCharge', { bookingNo: this.bookingNo })
        chargeInfo = res.data
      } 
      catch (e) 
      {
        console.error('[getCancelCharge]', e)
        this.hotelCancelLoading = false
        this.reqCxlHotelRequestOnly()
        return
      }
      this.hotelCancelLoading = false

      const chargeKrw = chargeInfo?.chargeKrw || 0
      const totalKrw  = this.hotelBookingInfo.selling_krw || 0
      const refundKrw = totalKrw - chargeKrw

      if (chargeKrw === 0) 
      {
        // ── 케이스 ② : 무료취소 (전액환불) ──
        const result = await this.$swal.fire({
          title: '예약 취소',
          html: `
            <div class="text-start" style="font-size:.88rem;">
              <p>✅ 취소 수수료가 없습니다. <b>전액 환불</b>됩니다.</p>
              <hr>
              <table style="width:100%; border-collapse:collapse;">
                <tr style="padding:.3rem 0;">
                  <td>결제금액</td>
                  <td class="text-end fw-bold">${this.getCurrencyFormat(totalKrw)}원</td>
                </tr>
                <tr>
                  <td>취소 수수료</td>
                  <td class="text-end" style="color:#16a34a; font-weight:700;">없음</td>
                </tr>
                <tr style="border-top:1px solid #e2e8f0;">
                  <td class="fw-bold">환불 예정금액</td>
                  <td class="text-end fw-bold" style="color:#1565c0;">${this.getCurrencyFormat(refundKrw)}원</td>
                </tr>
              </table>
              <p class="text-muted mt-2" style="font-size:.76rem;">
                환불은 결제수단으로 영업일 기준 3~5일 내 처리됩니다.
              </p>
            </div>`,
          showCancelButton: true,
          confirmButtonText: '취소 진행',
          cancelButtonText: '돌아가기',
          confirmButtonColor: '#c62828',
        })
        if (result.isConfirmed) 
        {
          await this.$nextTick()
          this.processCancelHotel(0)
        }
      } 
      else 
      {
        // ── 케이스 ③ : 수수료 발생 (부분환불) ──
        const result = await this.$swal.fire({
          title: '⚠️ 취소 수수료 발생',
          html: `
            <div class="text-start" style="font-size:.88rem;">
              <p class="fw-bold" style="color:#c62828;">현재 취소 시 수수료가 발생합니다.</p>
              <hr>
              <table style="width:100%; border-collapse:collapse;">
                <tr>
                  <td>결제금액</td>
                  <td class="text-end">${this.getCurrencyFormat(totalKrw)}원</td>
                </tr>
                <tr>
                  <td>취소 수수료</td>
                  <td class="text-end fw-bold" style="color:#c62828;">
                    - ${this.getCurrencyFormat(chargeKrw)}원
                  </td>
                </tr>
                <tr style="border-top:1px solid #e2e8f0;">
                  <td class="fw-bold">환불 예정금액</td>
                  <td class="text-end fw-bold" style="color:#1565c0;">
                    ${this.getCurrencyFormat(refundKrw)}원
                  </td>
                </tr>
              </table>
              <div style="background:#fffbeb; border:1px solid #fde68a; border-radius:8px;
                          padding:.75rem; margin-top:.8rem; font-size:.76rem; color:#78350f;">
                📋 ${this.hotelBookingInfo.cancel_remarks}
              </div>
            </div>`,
          showCancelButton: true,
          confirmButtonText: '취소 진행',
          cancelButtonText: '돌아가기',
          confirmButtonColor: '#c62828',
        })
        if (result.isConfirmed) 
        {
          await this.$nextTick()
          this.processCancelHotel(chargeKrw)
        }
      }
    },

    // ─── ② 실제 취소 실행 (RTX + Toss) ──────────────────────────
    async processCancelHotel(cancelFee) {
      this.$swal.fire({
        title: '취소 처리 중...',
        html: '잠시만 기다려 주세요.',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => this.$swal.showLoading()
      })

      try {
        const res = await axios.post('/api/hotel/cancelBooking', {
          bookingNo: this.bookingNo,
          cancelFee,                    // refundAmt는 백엔드에서 selling_krw - cancelFee로 계산
          cxlId: this.user.email,       // RTX 취소자 (현재 로그인한 사용자 이메일)
        })

        this.$swal.close()

        if (res.data.success) 
        {
          // ✅ 환불금액 계산 (selling_krw - cancelFee)
          let refundAmt = (this.hotelBookingInfo.selling_krw || 0) - cancelFee
          // ✅ 취소 알림톡 발송 (발송 실패해도 취소 처리에 영향 없음)
          this.sendKakaoHotelCancel(cancelFee, refundAmt)

          await this.$swal.fire(
            '취소 완료',
            '예약이 취소되었으며 환불이 처리됩니다.<br>영업일 기준 3~5일 내 환불됩니다.',
            'success'
          )
          this.hotelBookingInfo.status = 'bkg-cx'
        } 
        else 
        {
          this.$swal.fire(
            '오류',
            res.data.message || '취소 처리 중 오류가 발생했습니다.<br>고객센터(1660-4602)로 문의해주세요.',
            'error'
          )
        }
      } 
      catch (e) 
      {
        this.$swal.close()
        console.error('[processCancelHotel]', e)
        this.$swal.fire(
          '오류',
          '취소 처리 중 오류가 발생했습니다.<br>고객센터(1660-4602)로 문의해주세요.',
          'error'
        )
      }
    },

    // ── 호텔 취소 알림톡 발송(취소확정 CX) ──────────────────────────────────────
    sendKakaoHotelCancel(cancelFee = 0, refundAmt = 0) {
      const sendTargets = []
      this.handTel.forEach(h => {
        sendTargets.push({ callNo: h.aimCall, callName: h.handlerName ?? '담당자' })
      })
      sendTargets.push({
        callNo  : this.hotelBookingInfo.contact_no   || '',
        callName: this.hotelBookingInfo.contact_name || ''
      })

      let stayDateRange = `${this.getDateFormat(this.hotelBookingInfo.check_in)} ~ ${this.getDateFormat(this.hotelBookingInfo.check_out)}`
      let paxCnt        = `대인: ${this.hotelBookingInfo.adult_count || 0} / 소인: 0`
      let today         = new Date().toISOString().slice(0, 10)   // 취소일자 YYYY-MM-DD

      const promises = sendTargets.map(target => {
        const kakaoAlimData = {
          alimFlag    : 'CX',
          clientCall  : target.callNo,
          clientName  : target.callName,
          rtxName     : this.hotelBookingInfo.hotel_name,                  // PY와 동일 키
          resName     : this.hotelBookingInfo.hotel_name,                  // CX 템플릿용
          resPaxName  : this.hotelBookingInfo.contact_name,
          resPaxCnt   : paxCnt,
          resRoom     : this.hotelBookingInfo.room_count,
          resStayDate : stayDateRange,                                     // PY와 동일 키
          resPhone    : this.hotelBookingInfo.contact_no,
          resCode     : this.bookingNo,
          resDate     : today,                                             // 취소일자
          resPayAmount: this.getCurrencyFormat(refundAmt) + '원',          // 환불금액
          resFeeAmount: this.getCurrencyFormat(cancelFee) + '원',          // 취소수수료
          memFlag     : this.hotelBookingInfo.mem_flag || 'Y',
        }
        return this.$api('api/kakaoAlimSend10', { param: [{ kakaoAlimData }] })
          .catch(e => console.error('[호텔 취소 알림톡 실패]', target.callNo, e))
      })
      Promise.all(promises)
    },

    // ─── ③ 취소정책 없음 → 요청만 ────────────────────────────────
    async reqCxlHotelRequestOnly() {
      const result = await this.$swal.fire({
        title: '예약 취소 요청',
        html: `
          <div class="text-start" style="font-size:.88rem;">
            <p>취소 정책 확인이 필요합니다.</p>
            <p class="text-muted">
              취소 요청 접수 후 담당자가 확인하여 처리해드립니다.
            </p>
          </div>`,
        showCancelButton: true,
        confirmButtonText: '취소 요청',
        cancelButtonText: '돌아가기',
        confirmButtonColor: '#b45309',
      })
      if (!result.isConfirmed) return

      try {
        const res = await this.$api('/api/insReqCxlReserve', {
          param: [this.bookingNo, this.user.email, 'Y']
        })
        if (res.affectedRows > 0) {
          await this.$swal.fire(
            '',
            '취소 요청이 접수되었습니다.<br>담당자가 확인 후 연락드립니다.',
            'success'
          )
          this.hotelBookingInfo.status = 'bkg-cx'
        } else {
          this.$swal.fire(
            '오류',
            '요청 처리 중 오류가 발생했습니다.<br>고객센터(1660-4602)로 문의해주세요.',
            'error'
          )
        }
      } catch (e) {
        console.error('[reqCxlHotelRequestOnly]', e)
        this.$swal.fire('오류', '요청 처리 중 오류가 발생했습니다.', 'error')
      }
    },



    //엔버스가격구성
    async getNbusPrice(nbCode){
      //할인총액
      let pmFlag = "M"
      let nUseFlag = "Y"
      let nbusPriceSum = await this.$api("/api/nbusPriceSum", {param: [ nbCode, pmFlag, nUseFlag ]})
      //console.log("nbusPriceSum:", nbusPriceSum)
      if(nbusPriceSum.length > 0)
      {
        this.sumPrice_dc = (nbusPriceSum[0].sumPrice < 0) ? 0 : nbusPriceSum[0].sumPrice
      }
      //console.log("sumPrice_dc:", this.sumPrice_dc)

      let nbusPriceTot = await this.$api("/api/resNbusPrice", {param: [ nbCode, "Y"]})
      this.nbusPriceTot = (nbusPriceTot[0].result === undefined || !nbusPriceTot[0].result) ? 0 : nbusPriceTot[0].result
      //console.log("nbusPriceTot:", this.nbusPriceTot)
    },
    
    async getResCxlCheck(rCode){
      let cxlStatus = await this.$api("/api/checkReqCxl", {param: [rCode]});

      if(cxlStatus.length > 0)
      {
        this.cxlFlag = "Y"
      }

      //console.log("cxlFlag:", this.cxlFlag)
    },

    //상품정보
    async getProductInfo()
    {
      // NEW 가격정책(네이버 호환)
      let productInfo = await this.$api("/api/productDetail_new", {param: [this.productId]});

      if(productInfo.length > 0) 
      {
        this.productInfo = productInfo[0]
      }

      //console.log("productInfo:>>>>>>>>",this.productInfo);

      this.getProductTransInfoExited(); //기존교통정보

      // //포인트결제 가능여부 체크 => 포인트 결제제한 해제(2025-03-18)
      // if(this.productInfo.memLevel_P == "Y" || this.productInfo.memLevel_S == "Y" )
      // {
      //   this.canPayPointFlag = "N"
      // }
    },


    async getReserInfo()
    {
      //예약 또는 엔버스 정보마스터
      let reserveInfo = []

      //엔버스 루트
      let exist_nbRoute = []

      // 엔버스
      if(this.ctCode === "N")
      {
        reserveInfo = await this.$api("/api/reqResConsultDetail_nbus", {param: [this.reqRsvCode]});
        //엔버스문의 디테일(일정루트)
        exist_nbRoute = await this.$api("/api/nbusInqInfo_d", {param: [this.reqRsvCode]});

        if(reserveInfo.length > 0)
        {
          this.reserveInfo = reserveInfo[0]
          //이용시작일, 이용종료일
          this.reserveInfo.rentStartDate = this.getDateFormat(this.reserveInfo.rentStartDate);
          this.reserveInfo.insDate = this.getDateFormat(this.reserveInfo.insDate);
        }
        //console.log("reserveInfo:",this.reserveInfo)

        if(exist_nbRoute.length > 0)
        {
          this.exist_nbRoute = exist_nbRoute
        }
        //console.log("exist_nbRoute:",this.exist_nbRoute)
      }      
      
      // 엔타비, 엔데트
      else
      {
        let reserveInfo = []
        // NEW 예약이면 이 배열로 진행
        reserveInfo = await this.$api("/api/resConsultDetail_new", {param: [this.reqRsvCode]});
        //console.log("reserveInfo:>>>>", reserveInfo)

        this.newResFlag = (reserveInfo.length > 0) ? reserveInfo[0].newResFlag : "N"; //예약유형

        let reserveInfo_detail = []

        if(reserveInfo.length > 0)
        {
          // NEW 예약
          if(this.newResFlag === "Y") 
          {
            this.reserveInfo = reserveInfo[0];
            this.tot_perCount = reserveInfo[0].totalCount                                              //New가격에서는 상품구매수 = 인원수
            this.productCode = reserveInfo[0].reqPdtCode;
            //출발예정일-리턴예정일
            this.reserveInfo.reqDptDate = this.getDateFormat(this.reserveInfo.reqDptDate);
            this.reserveInfo.reqRtnDate = this.getDateFormat(this.reserveInfo.reqRtnDate);
            this.reserveInfo.reqDate = this.getDateFormat(this.reserveInfo.reqDate);                   //insDate 예약일

            reserveInfo_detail = await this.$api("/api/reservePriceInfo_new", {param: [this.reqRsvCode]});

            if(reserveInfo_detail.length > 0)
            {
              this.reserveInfo_detail = reserveInfo_detail[0]
              
              if(reserveInfo[0].addPdtFlag === "Y") 
              {
                this.addPdtFlag = "Y"
                let addPdtInfo = await this.$api("/api/addPdtInfo", {param: [ this.reqRsvCode ]})
                if(addPdtInfo.length > 0) 
                {
                  this.addPdtInfo = addPdtInfo
                }
                //console.log("this.addPdtInfo>>>>", this.addPdtInfo)
              }
            }
          }

          // 구유형 예약
          else 
          {
            reserveInfo = []
            reserveInfo = await this.$api("/api/resConsultDetail", {param: [this.reqRsvCode]});

            this.reserveInfo = reserveInfo[0];
            this.productCode = reserveInfo[0].reqPdtCode;
            this.reserveInfo.optDcPrice = (this.reserveInfo.optDcPrice == null) ? 0 : this.reserveInfo.optDcPrice
            
            this.email = (this.reserveInfo.conEmail == undefined || this.reserveInfo.conEmail == null) ? this.reserveInfo.reqEmail : this.reserveInfo.conEmail
            
            //출발예정일-리턴예정일
            this.reserveInfo.reqDptDate = this.getDateFormat(this.reserveInfo.reqDptDate);
            this.reserveInfo.reqRtnDate = this.getDateFormat(this.reserveInfo.reqRtnDate);
            this.reserveInfo.reqDate = this.getDateFormat(this.reserveInfo.reqDate); //insDate 예약일
            //this.pdtFlag = this.pdtCode.substring(0,2)
            this.pdtFlag = (this.productId.substring(0,2) === 'MX') ? "MX" : "SG"

            this.reqMarginRate = (this.reserveInfo.reqMarginRate == null) ? this.productInfo.basicMargin : this.reserveInfo.reqMarginRate;
            this.reqMarginMethod = (this.reserveInfo.reqMarginMethod == null) ? this.productInfo.marginMethod : this.reserveInfo.reqMarginMethod;

            reserveInfo_detail = await this.$api("/api/reservePriceInfo", {param: [this.reqRsvCode]});

            if(reserveInfo_detail.length > 0)
            {
              //환급은 당사자만 대상
              this.totRefundAmt = reserveInfo_detail[0].reqAdultMemP * 1
              this.reserveInfo_detail = reserveInfo_detail[0]
            }
          }

        }

        // console.log("reserInfo:>>>>", this.reserveInfo, ", reserveInfo_detail:::::", this.reserveInfo_detail, ", totRefundAmt:::::", this.totRefundAmt)
      }

        //가용포인트 체크
      // this.();
      
      //결제요청 여부
      this.getReqPayInfo(this.reqRsvCode);
      //리뷰작성가능체크
      this.checkReviewFlag();

      //취소요청여부체크
      this.getCheckReqCxl(this.reqRsvCode)

      if(this.ctCode === "Y")
      {
        if(this.newResFlag === "Y") 
        {
          // 선택형 옵션정보
          this.getSelOptInfo();
          // 직접형 옵션정보
          this.getDirOptInfo();
        }
        else 
        {
          // 선택된 옵션
          this.getSelOptions_new(this.reqRsvCode)
          // 선택된 추가상품
          this.getSelAddProductions(this.reqRsvCode)
        }
      }

      //엔버스인 경우 가격정보
      if(this.ctCode === "N")
      {
        this.getNbusPrice(this.reqRsvCode)
      }

      //취소요청여부 체크
      this.getResCxlCheck(this.reqRsvCode)      
    },

    // 선택형옵션 (NEW 예약용) 획득
    async getSelOptInfo() {
      let selOptInfo = await this.$api("/api/selOptInfo", {param: [this.reqRsvCode]});

      if(selOptInfo.length > 0)
      {
        this.selOptFlag = "Y"           //선택옵션유무
        this.selOptInfo = selOptInfo;
        this.getTotalPrice();
      }
      else
      {
        // 결제금액계산
        this.getTotalPrice();
      }
      //console.log("selOptInfo::::::::", this.selOptInfo)
    },

    // 직접형옵션 획득 (NEW 예약용)
    async getDirOptInfo() {
      let dirOptInfo = await this.$api("/api/dirOptInfo", {param: [this.reqRsvCode]});

      if(dirOptInfo.length > 0)
      {
        this.dirOptFlag = "Y"           //직접옵션유무
        this.dirOptInfo = dirOptInfo;
      }

      //console.log("dirOptInfo::::::::", this.dirOptInfo)
    },

    //결제총액추출 (NEW 예약용)
    getTotalPrice() {
      let totalPrice = 0
      // 무옵션 기본가격

      // 선택옵션의 총액
      if(this.selOptInfo.length > 0) {
        totalPrice = this.selOptInfo.reduce((sum, item) => sum + (item.optPrice * (item.qty_opt ?? 0)), 0);
      }

      this.pdtTotalPrice = totalPrice
      //this.rsvData_temp.reduce((sum, item) => sum + (item.pdtPrice * (item.count ?? 0)),0)
    },


    //선택옵션획득(선택옵션 중복선택방지 반영처리: 20240730)
    async getSelOptions_new(resCode) {
      let selOptions = []
      let useFlag = "Y"
      //let selOptNames_tmp = []

      //selOptions = await this.$api("/api/getSelOptions", {param: [resCode, useFlag]});
      selOptions = await this.$api("/api/getSelOptions_new", {param: [resCode, useFlag]});
      //console.log("selOptions:",selOptions);

      if(selOptions.length > 0)
      {
        this.selOptions = selOptions
        this.selOptFlag = "Y"

        let optName = ""                     //선택옵션명 
        let selOptPriceSelf = 0              //선택옵션 본인
        let selOptPriceRef  = 0              //선택옵션 환급액
        let selOptPriceAdu  = 0
        let selOptPriceTot_exSelf  = 0       //본인제외 동반옵션액(할인포함)
        let selOptPriceTot  = 0              //본인포함 동반옵션액(할인포함)
        let selOPtPriceDCTot_self = 0        //옵션할인본인
        let selOPtPriceDCTot_exSelf = 0      //옵션할인동반인(본인제외)
        let selOptPriceRef_tot = 0           //환급액총액
        // let selOptPriceChi  = []
        // let selOptPriceInf  = []

        // for(let i=0; i<selOptions.length; i++)
        // {
          optName = selOptions[0].optPdtName
          selOptPriceSelf =  selOptions[0].optPrice - selOptions[0].optPriceDCForStd
          selOptPriceRef  = (selOptions[0].optPriceRef_adu == undefined) ? 0 : selOptions[0].optPriceRef_adu
          selOptPriceAdu  = (selOptions[0].cntAdu > 1) ? (selOptions[0].optPrice - selOptions[0].optPriceDC_adu) : 0
          
          selOptPriceTot_exSelf  = selOptPriceAdu*(selOptions[0].cntAdu-1) + ((selOptions[0].optPrice_chi-selOptions[0].optPriceDC_chi)*selOptions[0].cntChi) + ((selOptions[0].optPrice_inf-selOptions[0].optPriceDC_inf)*selOptions[0].cntInf)

          selOptPriceTot = (selOptPriceRef > 0) ? (selOptPriceRef+selOptPriceTot_exSelf) : (selOptPriceSelf+selOptPriceTot_exSelf)
          selOPtPriceDCTot_self = (selOptions[0].optPrice - selOptPriceSelf)

          selOPtPriceDCTot_exSelf = (selOptions[0].optPriceDC_adu*(selOptions[0].cntAdu-1)) + ((selOptions[0].optPriceDC_chi)*selOptions[0].cntChi) + ((selOptions[0].optPriceDC_inf)*selOptions[0].cntInf)

          selOptPriceRef_tot = selOptPriceRef 

          //console.log(">>>>>",selOptPriceSelf, selOptPriceRef, selOptPriceAdu, selOptPriceTot_exSelf, selOptPriceTot, selOPtPriceDCTot_self, selOPtPriceDCTot_exSelf, selOptPriceRef_tot)
        // }
        this.optName = optName
        this.selOptPriceTot = selOptPriceTot
        this.selOPtPriceDCTot_self = selOPtPriceDCTot_self
        this.selOPtPriceDCTot_exSelf = selOPtPriceDCTot_exSelf
        this.selOptPriceRef_tot = selOptPriceRef_tot
        //console.log("this.selOptPriceTot:", this.selOptPriceTot, this.optName,">>>>", this.selOPtPriceDCTot_self, this.selOptPriceRef_tot)

      }
      else
      {
        this.selOptFlag  = "N"
        this.optName = "선택된 옵션이 없습니다"
      }
      //console.log(selOptPriceSelf)
      // console.log("selOptNames:", this.selOptNames)
    },


    //선택추가상품획득
    async getSelAddProductions(resCode) {
      let selAddPdt = []
      let useFlag = "Y"
      selAddPdt = await this.$api("/api/getSelAddProductions", {param: [resCode, useFlag]});

      if(selAddPdt.length > 0)
      {
        this.selAddPdt = selAddPdt
        this.selAddFlag = "Y"
        
        //선택추상가격*수량
        selAddPdt.forEach(sa => {
          this.tot_selAddPdtPrice += (sa.addPdtPrice * sa.qty_addPdt)
          this.selAddPdtNames.push(sa.addPdtName)
        });
      }
      else
      {
        this.selAddFlag = "N"
        this.selAddPdtNames = "없음"
      }
      // console.log("selAddPdtNames:", this.selAddPdtNames)
      //console.log("selAddPdt:",this.selAddPdt, "tot_selAddPdtPrice:", this.tot_selAddPdtPrice);
    },    

    async getProductImage() {
      // 상세페이지용 카로우셀 이미지
      let productImage = await this.$api("/api/productImage_new", {param: [this.productId,'T']});
      //this.productImage = (productImage.length > 0) ? productImage : "";
      if(productImage.length > 0)
      {
        this.productImage = productImage[0]
      }
      //console.log("productImage:",this.productImage)
    },
    //기존상품 프로모션정보
    async getPdtPromotion() {
      let pdtPromoInfo = await this.$api("/api/pdtPromo_existed", {param: [this.productId]});
      if(pdtPromoInfo.length > 0) {
        this.pdtPromoInfo = pdtPromoInfo[0];
        if(this.pdtPromoInfo.promoStart != undefined){
          this.pdtPromoInfo.promoStart = this.getDateFormat(this.pdtPromoInfo.promoStart);
        }
        if(this.pdtPromoInfo.promoEnd != undefined) {
          this.pdtPromoInfo.promoEnd = this.getDateFormat(this.pdtPromoInfo.promoEnd);
        }
      }
      //console.log("pdtPromoInfo:",this.pdtPromoInfo);
    },

    /** 카카오페이 처리로직 */
    async kPay()
    {
      //포인트처리
      let payByPoint = await this.$api("/api/payByPoint", {param: [
        this.reserveInfo.reqEmail,this.paidPoint,'S',this.reqRsvCode,'사용대기'
      ]});
      if(payByPoint.affectedRows < 0) 
      {
        this.$swal.fire('', '포인트 결제처리 중 오류가 발생하였습니다(코드: payByPoint)<br>포인트 복구문의: 1660-4602', 'error');
        return false;
      }
      else
      {
        // 성공 URL(핸들러등록)
        // const successUrl = `${window.location.protocol}//${window.location.host}/success_kPay&${this.reserveInfo.reqReserveCode}`;
        const successUrl = `${window.location.protocol}//${window.location.host}/success_kPay`;
        // 실패 or 취소 URL(핸들러등록)
        const failUrl = `${window.location.protocol}//${window.location.host}/fail_kPay`;

        let kakaoData = {
          'cid': '',
          'partner_order_id': this.reserveInfo.reqReserveCode,
          'partner_user_id': 'ntabi',
          'item_name': this.productInfo.pdtNameKor,
          'item_code': this.productId,
          'quantity': 1,
          'total_amount': this.reserveInfo.cstPrice_new,
          'vat_amount': this.reserveInfo.reqVatPrice,
          'tax_free_amount': this.reserveInfo.cstPrice_new - this.reserveInfo.reqVatPrice,
          'approval_url': successUrl,
          'fail_url': failUrl,
          'cancel_url': failUrl
        }

        //결제승인처리를 Success_kPay로 이동(20230321)
        try
        {
          //const response = await this.$api("api/kakaoPay", { param: kakaoData });
          const response = await axios.post('/api/kakaoPay', { param: kakaoData });
          const tid = response.data.tid;

          localStorage.setItem('tid', tid)
          localStorage.setItem('partner_order_id',kakaoData.partner_order_id)
          localStorage.setItem('total_amount',kakaoData.total_amount)

          const nextUrl = response.data.next_redirect_pc_url;
          window.location.href = nextUrl;
        }
        catch (error)
        {
          console.log(error);
        }
      }
    },

    //PG를 통하지 않는 결제결과 카톡발송
    async sendKakaoByPay(param, orderId, pPoint) //PY or WP, SP/NB or notSP
    {
      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        orderId, param, this.reserveInfo.conEmail
      ]});

      //알림톡 발송대상 확정
      this.handTel.push({aimCall: this.reserveInfo.reqTelNo})
      this.handTelCnt = this.handTel.length

      if(insKSendHistory.affectedRows > 0) 
      {
        let kakaoAlimData = {}
        let promises = []         //promise들의 배열
      
        let resPayAmount = 0
        if(this.payStyle === "p")
        {
          resPayAmount = pPoint
        }
        else
        { 
          resPayAmount = this.balance
        }
        let j = 0
        while(j < this.handTelCnt)
        {
          //let resPaxName = (this.reserveInfo.tripName == undefined || this.reserveInfo.tripName == "") ? this.reserveInfo.reqName : this.reserveInfo.tripName
          // let resPaxCnt = this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1
          let resPaxCnt = ""

          kakaoAlimData = 
          {
            //카카오 알림톡 발송(결제완료)
            clientName: this.reserveInfo.reqName,
            resName: this.productInfo.pdtNameKor,                             //예약상품명
            resPaxName: this.reserveInfo.tripName,
            resPaxCnt: resPaxCnt,
            dptDate: this.reserveInfo.reqDptDate,
            resPhone: this.reserveInfo.reqTelNo,
            resCode: orderId,
            resPayAmount: this.getCurrencyFormat(resPayAmount),
            resManager: this.productInfo.manName,
            alimFlag: param,                                                  //알림유형(결제완료)
            alimCall: this.handTel[j].aimCall,                                //알림톡발송대상
            pdtCode: this.productInfo.pdtCode                                 //비회원예약 결제처리용 상품코드
          };

          let promise = this.$api("api/kakaoAlimSend2", {
            param: [{ kakaoAlimData: kakaoAlimData}]
          })

          promises.push(promise)
          j++
        }
          
        //반복문 이후 처리
        Promise.all(promises).then(() => {
          this.$swal.fire('', '결제완료 알림톡이 발송되었습니다', 'success').then(() => {
            this.$router.push({ path: "/" });
          })
        }).catch((error) => {
          console.log("Error calling api: ", error)
        })
      }
    },

    //토스페이먼츠PG결제
    async pgPay(pFlag){
      if(this.pointForPay > 0)
      {
        let payByPoint = await this.$api("/api/payByPoint", {param: [
          this.reserveInfo.reqEmail,this.paidPoint,'S',this.reqRsvCode,'사용대기'
        ]});
        if(payByPoint.affectedRows < 0 || payByPoint.affectedRows == undefined)
        {
          this.$swal.fire('', '포인트 결제처리 중 오류가 발생하였습니다(코드: payByPoint)<br>포인트 복구문의: 1660-4602', 'error');
          return false;
        }
      }

      let veriSign = "N"
      let insVeriData = []

      //잔액결제청구처리
      let payAmount = 0
      let payPointAmt = (this.paidPoint == null || this.paidPoint == undefined) ? "0" : this.paidPoint
      let payCouponAmt = (this.payCoupon == null || this.payCoupon == undefined) ? "0" : this.payCoupon

      if(pFlag === "p2")
      {
        if(this.balance < 200 && this.balance >0)
        {
          this.$swal.fire("", "죄송합니다만, 온라인 결제는 200원 이상부터 가능합니다.<br><span class='text-danger'>마이페이지</span>로 이동합니다.", "info")
          .then(() => {            
            // location.reload(true)
            this.$router.push({path: '/myPage'})
          })
          //return false;
        }
        else
        {
          // 전액쿠폰결제 케이스
          if(payCouponAmt > 0 && this.balance == 0)
          {
            await this.payByPointOnly(this.reqRsvCode, "Y", this.payStyle, 0, payCouponAmt, "C")
          }

          payAmount = this.balance
          insVeriData = await this.$api("/api/proc_setVeriData_1", {param:
            [this.reserveInfo.reqReserveCode+"-2", payAmount, veriSign, pFlag, payPointAmt, payCouponAmt ]
          });
        }
      }
      else
      {
        if(this.ctCode === "N")         //엔버스
        {
          payAmount = this.reserveInfo.nbusPriceTot
          insVeriData = await this.$api("/api/proc_setVeriData", {param:
            [this.reserveInfo.inqCode, payAmount, veriSign, payPointAmt, payCouponAmt ]
          });
        }
        else                           // 엔타비, 엔데트
        {
          payAmount = this.reserveInfo.cstPrice_new
          insVeriData = await this.$api("/api/proc_setVeriData", {param:
            [this.reserveInfo.reqReserveCode, payAmount, veriSign, payPointAmt, payCouponAmt ]
          });
        }
      }

      if(insVeriData.affectedRows < 0)
      {
        this.$swal.fire("","검증데이타가 생성되지 않았습니다. 재시도해주세요", "warning")
        return false;
      }

      //localStorage.setItem('total_amount',this.reserveInfo.cstPrice_new)

      // //결제수단 랜더링
      // paymentWidget.renderPaymentMethods('#payment-widget', this.eventInfo.payAmt);

      // ------  결제위젯 초기화 ------
      // @docs https://docs.tosspayments.com/reference/widget-sdk#sdk-설치-및-초기화
      this.paymentWidget = await loadPaymentWidget(this.clientKey, ANONYMOUS);
      // ------  결제 UI 렌더링 ------
      // @docs https://docs.tosspayments.com/reference/widget-sdk#renderpaymentmethods선택자-결제-금액-옵션
      this.paymentMethodWidget = this.paymentWidget.renderPaymentMethods("#payment-method", { value: payAmount }, { variantKey: "DEFAULT" });
      // ------  이용약관 UI 렌더링 ------
      // @docs https://docs.tosspayments.com/reference/widget-sdk#renderagreement선택자-옵션
      //this.paymentWidget.renderAgreement("#agreement", { variantKey: "AGREEMENT" });
      this.showFlag = !this.showFlag      
    },

    async requestPayment(rNo, pFlag) {
      
      // 부분결제청구 처리
      let taxFreeAmount = 0
      let resCode = ""
      if(pFlag === "p2")
      {
        taxFreeAmount = this.balance
        resCode = rNo + "-2"
      }
      else
      {
        taxFreeAmount = this.reserveInfo.cstPrice_new
        resCode = rNo
      }

      //엔버스 결제금액
      if(this.ctCode === "N")
      {
        taxFreeAmount = this.reserveInfo.nbusPriceTot
      }
      else
      {
        taxFreeAmount = this.reserveInfo.cstPrice_new
      }

      try {
        if (this.paymentWidget) {
          // ------ '결제하기' 버튼 누르면 결제창 띄우기 ------
          // 결제를 요청하기 전에 orderId, amount를 서버에 저장하세요.
          // 결제 과정에서 악의적으로 결제 금액이 바뀌는 것을 확인하는 용도입니다.
          // @docs https://docs.tosspayments.com/reference/widget-sdk#requestpayment결제-정보
          if(this.ctCode === "N")
          {
            await this.paymentWidget.requestPayment({
              orderId: resCode,
              orderName: rNo,
              successUrl: 'http://localhost/success_pg',
              failUrl: 'http://localhost/fail_pg',
              // successUrl: 'https://ntabi.co.kr/success_pg',
              // failUrl: 'https://ntabi.co.kr/fail_pg',
              customerEmail: this.reserveInfo.inqEmail,
              customerName: this.reserveInfo.inqName,
              taxFreeAmount: taxFreeAmount,
            });
          }
          else
          {
            await this.paymentWidget.requestPayment({
              orderId: resCode,
              orderName: this.productInfo.pdtNameKor,
              // successUrl: 'http://localhost/success_pg',
              // failUrl: 'http://localhost/fail_pg',
              successUrl: 'https://ntabi.co.kr/success_pg',
              failUrl: 'https://ntabi.co.kr/fail_pg',
              customerEmail: this.reserveInfo.conEmail,
              customerName: this.reserveInfo.reqName,
              taxFreeAmount: taxFreeAmount,
            });
          }
        }
      } catch (error) {
        // 에러 처리하기
        console.error(error);
      }
    },


    /** 토스페이 처리로직 */
    async tPay(param, value)
    {
      if(value === "T")
      {
        //포인트처리
        let payByPoint = await this.$api("/api/payByPoint", {param: [
          this.reserveInfo.reqEmail,this.paidPoint,'S',this.reqRsvCode,'사용대기'
        ]});
        if(Object.keys(payByPoint)[0] === 'error') 
        {
          this.$swal.fire('', '포인트 결제처리 중 오류가 발생하였습니다(코드: payByPoint)<br>포인트 복구문의: 1660-4602', 'error');
          return false;
        }
        else
        {
          let tossData = {
            orderId: param,
            amount: this.reserveInfo.cstPrice_new,
            amountTaxFree: this.reserveInfo.cstPrice_new,
            //orderName: this.productInfo.pdtNameKor,
            productDesc: this.productInfo.pdtNameKor,
            autoExecute: true,
            // retUrl: "http://test.somen.co.kr:8088/success?amount="+this.reserveInfo.cstPrice_new,
            // retCancelUrl: "http://test.somen.co.kr:8088/fail",
            retUrl: "https://ntabi.co.kr/success?amount="+this.reserveInfo.cstPrice_new,
            retCancelUrl: "https://ntabi.co.kr/fail",
            resultCallback: "https://ntabi.co.kr/callback",
          }
          //console.log("tossData:",tossData)

          // connect with api on backend
          this.$api("api/tossPay/start",
          {
            param: tossData
          })
          .then((res) => {
            console.log(res);
            window.location.href = res.checkoutPage;
          })
          .catch((err) => {
            console.error(err);
          });
        }
      }
    },

    async freePay(rNo, pFlag)
    {
      // 부분결제청구 처리
      let taxFreeAmount = 0
      if(pFlag === "p2")
      {
        taxFreeAmount = this.balance
      }
      else
      {
        taxFreeAmount = this.reserveInfo.cstPrice_new
      }
            
      //포인트처리
      let payByPoint = await this.$api("/api/payByPoint", {param: [
        this.reserveInfo.reqEmail,this.paidPoint,'S',this.reqRsvCode,'사용대기'
      ]});
      if(payByPoint.affectedRows < 0) 
      {
        this.$swal.fire('', '포인트 결제처리 중 오류가 발생하였습니다(코드: payByPoint)<br>포인트 복구문의: 1660-4602', 'error');
        return false;
      }
      else
      {
        //결제처리
        let payByUser = await this.$api("/api/payByUser", {param: [taxFreeAmount, this.user.email, '000', rNo]});
        
        if(payByUser.affectedRows > 0) 
        {
          let upd_UsePoint = await this.$api("/api/upd_UsePoint", {param: [ this.user.email, rNo ]});
          if(upd_UsePoint.affectedRows < 0 || upd_UsePoint.affectedRows == undefined )
          {
            this.$swal.fire("","죄송합니다. 결제처리에 오류가 발생했습니다(코드:upd_UsePoint).<br>문의처: 1660-4602","warning")
            return false        
          }
          else
          {
            this.getPayDetailInfo(rNo)
            this.$swal.fire('','전액 포인트 결제되었습니다. 감사합니다,', 'success');
            //location.reload(true);
          }
        }
        else 
        {
          this.$swal.fire('','결제처리 중 에러가 발생했습니다(코드: payByUser)<br>문의처(1660-4602)에 확인을 요청해주세요.', 'error')
          return false;
        }
      }
    },
    // //카톡발송 없이 결제상세만 체크
    // async getPayDetailInfo1(orderId)
    // {
    //   let resNo = orderId
    //   let payDetailInfo = await this.$api("/api/payDetailInfo", {param: [resNo]});
    //   if(payDetailInfo.length > 0)
    //   {
    //     this.payDetailInfo = payDetailInfo[0];
    //     console.log("payDetailInfo1:", this.payDetailInfo)
    //   }
    // },    
    async getPayDetailInfo(orderId)
    {
      let resNo = orderId
      let payDetailInfo = []
      if(this.ctCode === "N")
      {
        payDetailInfo = await this.$api("/api/payDetailInfo_nbus", {param: [resNo]});        
      }
      else
      {
        payDetailInfo = await this.$api("/api/payDetailInfo", {param: [resNo]});
      }

      if(payDetailInfo.length > 0)
      {
        this.payDetailInfo = payDetailInfo[0];
        //console.log("payDetailInfo:", this.payDetailInfo)
        //결제완료 카톡안내
        this.sendKakao("PY", resNo);
      }
    },

    toReview(rsvNo)
    {
      //엔버스
      if(this.ctCode === "N")
      {
        if(this.reserveInfo.inqStatus != "CO")
        {
          this.$swal.fire({
            html: '<small class="text-muted">리뷰작성기간이 아닙니다</small>',
            width: 'auto',
            height: 'auto',
            showConfirmButton: false
          })
          return false;
        }
        else
        {
          //this.$router.push({path: '/reviewCreate', query: {rsvNo: rsvNo, cCode: "N"}});

          let sDate = new Date(this.reserveInfo.rentStartDate)
          let tEndDate = sDate.setDate(sDate.getDate() + this.reserveInfo.rentTotDays)

          // 입력된 일자(yyyy-mm-dd)를 Date 객체로 변환
          let inputDate = new Date(tEndDate);

          // 오늘 날짜를 Date 객체로 생성.
          const today = new Date();

          // 여행종료일이 오늘이전=>리뷰작성
          if (inputDate < today)
          {
            this.$router.push({path: '/reviewCreate', query: {rsvNo: rsvNo, cCode: "N"}});
          }
          else
          {
            this.$swal.fire({
              position: 'top-end',
              // icon: 'warning',
              html: '<h6 class="text-danger">작성가능기간이 아닙니다.</h6>',
              width: 'auto',
              height:'auto',
              toast: true,
              showConfirmButton: false,
              timer: 1000
            })
            return false;
          }
        }
      }
      
      //엔타비, 엔데트
      else
      {
        if(this.reserveInfo.reqStatus != "CO")
        {
          this.$swal.fire({
            html: '<small class="text-muted">리뷰작성기간이 아닙니다</small>',
            width: 'auto',
            height: 'auto',
            showConfirmButton: false
          })
          return false;
        }
        else
        {
          let tEndDate = this.reserveInfo.reqRtnDate == null ? this.reserveInfo.reqDptDate : this.reserveInfo.reqRtnDate

          /** 작성일자기한 체크 */
          // 입력된 일자(yyyy-mm-dd)를 Date 객체로 변환
          let inputDate = new Date(tEndDate);

          // 오늘 날짜를 Date 객체로 생성.
          const today = new Date();

          // 여행종료일이 오늘이전=>리뷰작성
          if (inputDate < today)
          {
            this.$router.push({path: '/reviewCreate', query: {rsvNo: rsvNo, tEndDate:tEndDate, pCode: this.productId}});

            // // 입력된 일자에서 14일 후의 일자를 계산
            // let deadline = new Date(inputDate.getTime() + (30 * 24 * 60 * 60 * 1000));

            // // 현재 일자와 입력된 일자에서 14일 후의 일자를 비교
            // if (today > deadline) {
            //   this.$swal.fire({
            //     position: 'top-end',
            //     // icon: 'warning',
            //     html: '<h6 class="text-danger">작성기한이 지났습니다.</h6>',
            //     width: 'auto',
            //     height:'auto',
            //     toast: true,
            //     showConfirmButton: false,
            //     timer: 1000
            //   })
            //   return false;
            // }
            // else
            // {
            //   this.$router.push({path: '/reviewCreate', query: {rsvNo: rsvNo, tEndDate:tEndDate, pCode: this.productId}});
            // }
          }
          else
          {
            this.$swal.fire({
              position: 'top-end',
              // icon: 'warning',
              html: '<h6 class="text-danger">작성가능기간이 아닙니다.</h6>',
              width: 'auto',
              height:'auto',
              toast: true,
              showConfirmButton: false,
              timer: 1000
            })
            return false;
          }
        }
      }

    },

    //후기작성 가능여부체크(기존 후기존재여부)
    async checkReviewFlag()
    {
      let checkReviewFlag = await this.$api("/api/checkReviewFlag", {param: [this.user.email, this.reserveInfo.reqReserveCode]});
      //console.log("checkReviewFlag:",checkReviewFlag)
      if(checkReviewFlag.length > 0)
      {
        this.isReviewFlag = checkReviewFlag[0].nUseFlag
      }
      else
      {
        this.isReviewFlag = "N"
      }
      //console.log("isReviewFlag:", this.isReviewFlag)
    },

    //부분결제기능 도입 후, 결제판정로직 변경(2024-05)
    async getReqPayInfo(val)
    {
      let resCode = ""
      if(this.reserveInfo.partFlag === "1")
      {
        resCode = val+"-1"
      }
      else if(this.reserveInfo.partFlag === "2")
      {
        resCode = val+"-1"
      }
      else            // null 또는 fu
      {
        resCode = val
      }

      let rtnRPflag_tmp = await this.$api("/api/getReqPayInfo", {param: [resCode]});

      //console.log("rtnRPflag_tmp:????", rtnRPflag_tmp)
      
      //포인트 외 쿠폰결제도 추가(20250325)
      if(rtnRPflag_tmp.length > 0)
      {
        //this.rtnRPflag = "Y"    //결제여부

        if(rtnRPflag_tmp[0].reqPayStatus === "CO")      //확정
        {
          //this.payStyle = "f"
          this.paidFlag = "Y"
        }        
        else if(rtnRPflag_tmp[0].reqPayStatus === "PY" && (rtnRPflag_tmp[0].payFlag === "fu" || rtnRPflag_tmp[0].payFlag === "p2" || rtnRPflag_tmp[0].payFlag == null))
        {
          this.payStyle = "f"
          this.paidFlag = "Y"
        }
        else if(rtnRPflag_tmp[0].reqPayStatus === "PY" && rtnRPflag_tmp[0].payFlag === "p1")
        {
          this.payStyle = "p"
          this.paidFlag = "Y"
          if(rtnRPflag_tmp[0].payPointAmt < 0 || rtnRPflag_tmp[0].payPointAmt == undefined)
          {
            rtnRPflag_tmp[0].payPointAmt = 0
          }
          if(rtnRPflag_tmp[0].payCouponAmt < 0 || rtnRPflag_tmp[0].payCouponAmt == undefined)
          {
            rtnRPflag_tmp[0].payCouponAmt = 0
          }

          // this.balance = (this.reserveInfo.totalPrice)*1 - (rtnRPflag_tmp[0].actualPayAmount)*1 - (rtnRPflag_tmp[0].payPointAmt*1) - (rtnRPflag_tmp[0].payCouponAmt*1)

          this.balance = this.reserveInfo.balance*1

        }
        else if(rtnRPflag_tmp[0].reqPayStatus === "RP" && rtnRPflag_tmp[0].payFlag == null)
        {
          this.paidFlag = "Y"
          this.rtnRPflag = "Y"      //과거 로직에 사용하던 변수로 미사용일 가능성이 높으나 일단 변수값은 생성함
        }
        else if(rtnRPflag_tmp[0].reqPayStatus === "RP" && rtnRPflag_tmp[0].payFlag === 'p1')        //부분결제 시, 잔여대금
        {
          this.paidFlag = "Y"           //부분결제
          // this.balance = (this.reserveInfo.totalPrice)*1 - (rtnRPflag_tmp[0].actualPayAmount)*1
          this.balance = this.reserveInfo.balance*1
          // this.balance = (rtnRPflag_tmp[0].reqTotPayAmt)*1 - (rtnRPflag_tmp[0].actualPayAmount)*1
        }
        else if(rtnRPflag_tmp[0].reqPayStatus === "RP" && (rtnRPflag_tmp[0].payFlag === 'p2' || rtnRPflag_tmp[0].payFlag === 'fu'))
        {
          if(rtnRPflag_tmp[0].actualPayAmount != rtnRPflag_tmp[0].reqTotPayAmt)
          {
            this.$swal.fire("","최종결제금액과 상품대금이 일치하지 않습니다. 실제결제된 금액을 확인해주세요", "question")
            return false
          }
          else
          {
            this.paidFlag = "Y"       //전액결제
            this.rtnRPflag = "Y"
          }
        }

        //관리자화면의 펑션에서는 this.userPayInfo로 변경됨
        //this.userPayInfo = rtnRPflag_tmp[0]
        this.rtnRPflag_tmp = rtnRPflag_tmp[0]

        //console.log("balance:", this.balance, "payStyle:", this.payStyle)

        //포인트결제내역
        let payPointInfo = await this.$api("/api/payPointInfo", {param: [val]});
        
        //결제포인트액수
        if(payPointInfo[0].payPoint > 0)
        {
          this.payPointAmt = payPointInfo[0].payPoint
        }
        else
        {
          this.payPointAmt = 0
        }
      }
      else
      {
        this.rtnRPflag = "N"
        this.paidFlag = "N"
      }

      if(this.paidFlag != "N")
      {
        // 결제히스토리용(p2내역추가 20250307)
        this.userPayInfo = rtnRPflag_tmp[0]
        this.p1PayAmt = (this.userPayInfo.p1PayAmt == undefined) ? 0 :          this.userPayInfo.p1PayAmt
        this.p2PayAmt = (this.userPayInfo.p2PayAmt == undefined) ? 0 :          this.userPayInfo.p2PayAmt
        this.p1PayDate = (this.userPayInfo.p1PayDate == undefined) ? "" :       this.getKorDateFormat(this.userPayInfo.p1PayDate)
        this.p2PayDate = (this.userPayInfo.p2PayDate == undefined) ? "" :       this.getKorDateFormat(this.userPayInfo.p2PayDate)
        this.payPointAmt = (this.userPayInfo.payPointAmt == undefined) ? 0 :    this.userPayInfo.payPointAmt
        this.payPointDate = (this.userPayInfo.payPointDate == undefined) ? "" : this.getKorDateFormat(this.userPayInfo.payPointDate)
        this.payPointAmt2 = (this.userPayInfo.payPointAmt2 == undefined) ? 0 :    this.userPayInfo.payPointAmt2
        this.payPointDate2 = (this.userPayInfo.payPointDate2 == undefined) ? "" : this.getKorDateFormat(this.userPayInfo.payPointDate2)
        this.payCouponAmt = (this.userPayInfo.payCouponAmt == undefined) ? 0 :    this.userPayInfo.payCouponAmt
        this.payCouponDate = (this.userPayInfo.payCouponDate == undefined) ? "" : this.getKorDateFormat(this.userPayInfo.payCouponDate)
        this.payCouponAmt2 = (this.userPayInfo.payCouponAmt2 == undefined) ? 0 :    this.userPayInfo.payCouponAmt2
        this.payCouponDate2 = (this.userPayInfo.payCouponDate2 == undefined) ? "" : this.getKorDateFormat(this.userPayInfo.payCouponDate2)

        this.totalPay = this.p1PayAmt*1 + this.p2PayAmt*1 + this.payPointAmt*1 + this.payCouponAmt*1
      }

      let fPayFlag = ""       //전액Y, 부분N
      if(this.userPayInfo.reqTotPayAmt == this.p1PayAmt + this.payPointAmt + this.payCouponAmt)
      {
        fPayFlag = "Y"         //전액결제
      }
      else
      {
        fPayFlag = "N"        //부분결제
      }

      this.fPayFlag = fPayFlag
    },


    /** 두날짜 사이의 날짜추출함수 */
    getDatesStartToLast(startDate, lastDate) {
      //var regex = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
      //if(!(regex.test(startDate) && regex.test(lastDate))) return "Not Date Format";
      if(!(startDate && lastDate)) return "Not Date Format";

      var result = [];
      var curDate = new Date(startDate);
      while(curDate <= new Date(lastDate)) {
        result.push(curDate.toISOString().split("T")[0]);
        curDate.setDate(curDate.getDate() + 1);
      }
      return result;
    },

    async getReqProcLevel() {
      let rProc = await this.$api("/api/reqProcLevel", {});
      if(rProc.length > 0) {
        this.rProc = rProc
      }
      //console.log("rProc:",this.rProc);
    },

    //기존상품 교통정보
    async getProductTransInfoExited() {
      let pdtTransInfo1 = await this.$api("/api/pdtTransInfo_existed", {param: [this.productId]});
      if(pdtTransInfo1.length > 0) {
        this.pdtTransInfo1 = pdtTransInfo1[0];
      }
      //console.log("pdtTransInfo1:",this.pdtTransInfo1);
    },

    //상품가격
    async getProductPrice() {
      let productPrice = await this.$api("/api/productPrice", {param: [this.pdtCode]});
      this.productPrice = productPrice;
      //console.log("productPrice:",this.productPrice);

      if(this.productInfo.etcOptionFlag === "Y") {
        this.getEtcOptionInfo();
      }
    },

    //기타옵션획득
    async getEtcOptionInfo() {
      let etcOptionInfo = []
      etcOptionInfo = await this.$api("/api/etcOptionInfo1", {param: [this.productId]});

      if(etcOptionInfo.length > 0)
      {
        this.etcOptionInfo = etcOptionInfo
      }
      //console.log("etcOptionInfo:",this.etcOptionInfo);
    },
    async getPromotionList() {
      let promotionList = await this.$api("/api/promotionList", {param: [this.productId]});
      this.promoList = promotionList;
      // console.log("promoList:",this.promoList, "pDetail:",this.productDetail.deliCategory);
    },
    goToMypage() {
      //this.$router.push({path: '/reserveInfoList_client'});
      this.$router.push({path: '/myPage'});
    },

    goToProductDetail(pdtCode){
      let salesRoute = pdtCode.charAt(0)
      this.$router.push({path: '/detail', query:{productId: pdtCode, salesRoute: salesRoute}});
    },

    // 1:1문의하기 (예약유형별 참조코드 + ctCode 전달)
    goToCustomerAsk() {
      let bookId = ''

      if (this.ctCode === 'H') 
      {
        // 호텔예약
        bookId = this.hotelBookingInfo.booking_no
        this.$router.push({path: '/customerAsk', query: { ctCode: this.ctCode, bookId: bookId } })
      } 
      else if (this.ctCode === 'N') 
      {
        // 엔버스
        bookId = this.reserveInfo.inqCode
        this.$router.push({path: '/customerAsk', query: { ctCode: this.ctCode, bookId: bookId } })
      } 
      else 
      {
        // 일반상품 (엔타비/엔데트)
        bookId = this.reserveInfo.reqReserveCode
        this.$router.push({path: '/customerAsk', query: { ctCode: this.ctCode, bookId: bookId, pCode: this.productId } })
      }
    },

    /** 두배열간 중복제거 */
    removeDubofArrays(arr1, arr2)
    {
      return arr1.concat(arr2).filter(item => !arr1.includes(item) || !arr2.includes(item));     
    },

    //취소요청여부체크
    async getCheckReqCxl(rCode){
      //기존요청이 있는지 체크
      let res_checkReqCxl = await this.$api("/api/checkReqCxl", {param: [rCode]})
      if(res_checkReqCxl.length > 0)
      {
        this.res_checkReqCxl = res_checkReqCxl[0]
      }
    },
    
    //취소요청처리
    async reqCxl(rCode, pCode){

      //상품별 취소안내사항
      let res_supCxl = await this.$api("/api/supCxl", {param: pCode})

      let supCxl = ""
      if(res_supCxl.length > 0)
      {
        supCxl = res_supCxl[0]
      }

      this.$swal.fire({
        html: "예약취소를 요청하시겠습니까?<br><br><p class='text-start swal-popup'>"+ supCxl.supCancellation.split('\n').join('<br>') +"</p>",
        showCancelButton: true,
        confirmButtonText: '동의하고 요청합니다',
        cancelButtonText: '요청하지 않습니다',
      }).then(async (result) => {
        if(result.isConfirmed) {
          let conFlag = "Y"   //취소약관동의
          let insReqCxlReserve = await this.$api("/api/insReqCxlReserve", {param: [
            rCode, this.user.email, conFlag
          ]});
          if(insReqCxlReserve.affectedRows < 0 || insReqCxlReserve.affectedRows === undefined) 
          {
            this.$swal.fire('','요청처리 중 오류가 발생했습니다.<br>온라인 문의 또는 연락(1660-4602)을 주시면 신속하게 처리해드리겠습니다.', 'warning')
            return false;
          }
          else
          {
            this.sendKakao("RCX", rCode)
          }
        }
      })
    },

    //엔버스예약 취소요청
    async reqCxl_nbus(nCode){
      //상품별 취소안내사항
      let res_supCxl = await this.$api("/api/supCxl_nbus", {param: nCode})

      let supCxl = ""
      if(res_supCxl.length > 0)
      {
        supCxl = res_supCxl[0]
      }
      this.$swal.fire({
        html: "예약취소를 요청하시겠습니까?<br><br><p class='text-start swal-popup'>"+ supCxl.supCancellation.split('\n').join('<br>') +"</p>",
        showCancelButton: true,
        confirmButtonText: '동의하고 요청합니다',
        cancelButtonText: '요청하지 않습니다',
        width: 1000,
      }).then(async (result) => {
        if(result.isConfirmed) {
          let conFlag = "Y"   //취소약관동의
          let insReqCxlReserve = await this.$api("/api/insReqCxlReserve", {param: [
            nCode, this.user.email,conFlag
          ]});
          if(Object.keys(insReqCxlReserve)[0] === 'error') 
          {
            this.$swal.fire('','요청처리 중 오류가 발생했습니다.<br>온라인 문의 또는 연락(1660-4602)을 주시면 신속하게 처리해드리겠습니다.', 'warning')
            return false;
          }
          else
          {
            this.sendKakao("RCX", nCode)
          }
        }
      })
    },


    //카카오발송대상자 정리
    async getHandlerInfo()
    {
      let handTel = await handlerInfo(this.$api);
      if(handTel.length > 0)
      {
        this.handTel = handTel
      }
      //console.log("handTel: ", this.handTel)
    },

    /** 카카오알림 발송 */
    async sendKakao(param, resNo)
    {
      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        //this.orderId, param, this.userInfo
        resNo, param, this.user.email
      ]});

      //알림톡 발송대상 확정
      if(this.ctCode === "N")      //엔버스
      {
        this.handTel.push({aimCall: this.reserveInfo.inqTel})        
      }
      else                            //일반여행상품
      {
        this.handTel.push({aimCall: this.reserveInfo.reqTelNo})
      }
      this.handTelCnt = this.handTel.length

      //let kakaoAlimData = {}
      if(insKSendHistory.affectedRows > 0) {
        let promises = []

        if(param == "PY") 
        {
          for(let i=0; i<this.handTelCnt; i++)
          {
            let kakaoAlimData = 
            {
              //카카오 알림톡 발송(결제완료)
              clientName: this.payDetailInfo.clientName,
              resName: this.payDetailInfo.resName,
              resPaxName: this.payDetailInfo.resPaxName,
              resPaxCnt: this.payDetailInfo.resPaxCnt,
              dptDate: this.payDetailInfo.dptDate,
              resPhone: this.payDetailInfo.resPhone,
              resCode: resNo,
              resPayAmount: this.getCurrencyFormat(this.payDetailInfo.resPayAmount),
              //resPayAmount: this.getCurrencyFormat(this.rtnRPflag_tmp.actualPayAmount)+"P",
              resManager: this.payDetailInfo.resManager,
              alimFlag: param,                                             //알림유형(결제완료)
              clientCall: this.handTel[i].aimCall,                           //알림톡발송대상
            };

            let promise = this.$api("api/kakaoAlimSend2", {
              param: [ { kakaoAlimData: kakaoAlimData} ]
            })

            promises.push(promise)            
          }
          //반복문 이후 처리
          Promise.all(promises).then((results) => {
            console.log(results)
            this.$swal.fire('', '결제완료 알림톡이 발송되었습니다', 'success').then(() => {
              location.reload(true)
            })
          }).catch((error) => {
            console.log("Error calling api: ", error)
          })

          // this.$api("api/kakaoAlimSend2", {
          //   param: [
          //     { kakaoAlimData: kakaoAlimData},
          //   ]
          // }).then((res) => {console.log(res)});
          // this.$swal.fire('', '결제완료 알림톡이 발송되었습니다', 'success');
          // //this.$router.push({path: '/'});
          // location.reload(true);
          // //history.back();
        }

        //취소요청접수 알림톡
        else if(param == "RCX") 
        {
          let resPaxCnt = 0

          if(this.ctCode === "N")
          {
            resPaxCnt = this.reserveInfo.personCnt*1
          }
          else
          {
            // resPaxCnt = this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1
            resPaxCnt = ""
          }

          //취소요청 카카오 알림톡
          let kakaoAlimData = {}

          //엔버스
          if(this.ctCode === "N")
          {
            for(let i=0; i<this.handTelCnt; i++)
            {
              kakaoAlimData = 
              {
                inqName: this.reserveInfo.inqName,
                inqCode: resNo,
                rentStartDate: this.getDateFormat(this.reserveInfo.rentStartDate),
                inqTel: this.reserveInfo.inqTel,
                alimFlag: "RCX",                                             //알림유형(RCX:취소요청)
                clientCall: this.handTel[i].aimCall,                           //알림톡발송대상
                memFlag: "Y",
              };
              //console.log("kakaoAlimData:", kakaoAlimData)

              let promise_n = this.$api("api/kakaoAlimSend7", {
                param: [ { kakaoAlimData: kakaoAlimData} ]
              })

              promises.push(promise_n)
            }
          }
          //일반예약
          else
          {
            for(let i=0; i<this.handTelCnt; i++)
            {
              kakaoAlimData = 
              {
                clientName: this.reserveInfo.reqName,
                resName: this.productInfo.pdtNameKor,
                resPaxName: this.reserveInfo.reqName,
                resPaxCnt: resPaxCnt,
                dptDate: this.reserveInfo.reqDptDate,
                resPhone: this.reserveInfo.reqTelNo,
                //resCode: this.reserveInfo.reqReserveCode,
                resCode: resNo,
                resManager: this.productInfo.handlerNameKor,
                alimFlag: param,                                               //알림유형(취소요청)
                clientCall: this.handTel[i].aimCall,                           //알림톡발송대상
              };
              let promise = this.$api("api/kakaoAlimSend2", {
                param: [ { kakaoAlimData: kakaoAlimData} ]
              })

              promises.push(promise)
            }
          }

          //반복문 이후 처리
          Promise.all(promises).then((results) => {
            console.log("result:", results)
            this.$swal.fire('', '취소요청 알림톡이 발송되었습니다', 'success').then(() => {
              //location.reload(true)
            })
          }).catch((error) => {
            console.log("Error calling api: ", error.response ? error.response.data : error);
          })
        }        
      }
    },
  }
}
</script>

<style scoped>
/* =============================================
   CSS Variables - ntabi 브랜드 컬러
============================================= */
#reserdetail {
  --green:        #86cd53;
  --green-dark:   #5fa033;
  --green-light:  #d4f0b8;
  --green-xlight: #f0fbe7;
  --charcoal:     #2b3a2b;
  --charcoal-light: #3d5c3d;
  --teal:         #3aab6f;
  --bg:           #f5faf2;
  --border:       #ddefd4;
  --shadow:       rgba(90, 160, 51, 0.10);
  --text-main:    #1a2e1a;
  --text-sub:     #5a7a5a;
  --text-muted:   #8aaa8a;
  --radius:       14px;
  --radius-sm:    8px;
  --white:        #ffffff;
}

/* =============================================
   Layout
============================================= */
.rd-wrap {
  background: var(--bg);
  min-height: 100vh;
}
.rd-section {
  padding: 2rem 0 5rem;
}
@media (max-width: 991px) {
  .rd-section { padding: 1rem 0 4rem; }
}

/* PC/Mobile 토글 */
#reserdetail .pc   { display: block; }
#reserdetail .mobile { display: none; }
@media (max-width: 991px) {
  #reserdetail .pc   { display: none; }
  #reserdetail .mobile { display: block; }
}

/* =============================================
   페이지 헤더
============================================= */
.rd-page-header {
  text-align: center;
  padding: 2.5rem 0 2rem;
}
.rd-header-badge {
  display: inline-flex;
  align-items: center;
  gap: .4rem;
  background: var(--green-light);
  color: var(--green-dark);
  font-size: .72rem;
  font-weight: 700;
  letter-spacing: .12em;
  padding: .28rem .9rem;
  border-radius: 20px;
  margin-bottom: .8rem;
}
.rd-page-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--charcoal);
  margin: 0 0 .4rem;
}
.rd-page-sub {
  font-size: .88rem;
  color: var(--text-sub);
  margin: 0;
}
@media (max-width: 991px) {
  .rd-page-title { font-size: 1.4rem; }
  .rd-page-header { padding: 4rem 0 1rem; }
}

/* =============================================
   카드 공통
============================================= */
.rd-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: 0 2px 16px var(--shadow);
  margin-bottom: 1.5rem;
  overflow: hidden;
  transition: box-shadow .2s;
}
.rd-card:hover {
  box-shadow: 0 4px 24px rgba(90, 160, 51, 0.15);
}
.rd-card-header {
  display: flex;
  align-items: center;
  gap: .6rem;
  background: var(--charcoal);
  color: var(--white);
  padding: .85rem 1.4rem;
  font-size: .95rem;
  font-weight: 600;
  letter-spacing: .02em;
}
.rd-card-header i { color: var(--green-light); font-size: 1.05rem; }
.rd-card-body { padding: 1.6rem; }
@media (max-width: 991px) {
  .rd-card-body { padding: 1.1rem; }
}

/* =============================================
   상품 헤더
============================================= */
.rd-product-card .rd-card-body { padding: 0; }

/* 일반상품 */
.rd-product-header {
  display: flex;
  gap: 0;
}
.rd-product-img-wrap {
  flex: 0 0 260px;
}
.rd-product-img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
}
.rd-product-meta {
  flex: 1;
  padding: 1.4rem 1.6rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.rd-product-code {
  font-size: .72rem;
  color: var(--text-muted);
  font-weight: 500;
  letter-spacing: .04em;
  display: block;
  margin-bottom: .3rem;
}
.rd-product-name {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--charcoal);
  margin: 0 0 .6rem;
  line-height: 1.4;
}
.rd-reserve-code-wrap {
  display: flex;
  align-items: center;
  gap: .5rem;
  margin-bottom: .8rem;
}
.rd-reserve-code {
  font-size: 1rem;
  font-weight: 700;
  color: var(--green-dark);
}

/* 엔버스 헤더 */
.rd-nbus-header {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 1.6rem;
  flex-wrap: wrap;
}
.rd-nbus-icon {
  width: 56px;
  height: 56px;
  background: var(--green-xlight);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: var(--green-dark);
  flex-shrink: 0;
}
.rd-nbus-info { flex: 1; }
.rd-nbus-code {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--green-dark);
  margin: 0;
}

/* 액션 버튼 */
.rd-product-actions {
  display: flex;
  gap: .5rem;
  flex-wrap: wrap;
}
.rd-action-btn {
  display: inline-flex;
  align-items: center;
  gap: .3rem;
  font-size: .8rem;
  font-weight: 600;
  color: var(--white);
  background: var(--green-dark);
  border: none;
  border-radius: var(--radius-sm);
  padding: .42rem .9rem;
  cursor: pointer;
  transition: background .2s, transform .1s;
}
.rd-action-btn:hover { background: var(--charcoal); transform: translateY(-1px); }
.rd-action-btn--outline {
  background: transparent;
  color: var(--green-dark);
  border: 1.5px solid var(--green-dark);
}
.rd-action-btn--outline:hover { background: var(--green-xlight); color: var(--charcoal); }

@media (max-width: 991px) {
  .rd-product-header { flex-direction: column; }
  .rd-product-img-wrap { flex: unset; width: 100%; }
  .rd-product-img { height: 180px; border-radius: 0; }
  .rd-product-meta { padding: 1rem; }
}

/* =============================================
   정보 그리드 (PC)
============================================= */
.rd-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}
.rd-info-item {
  display: flex;
  flex-direction: column;
  gap: .35rem;
  padding: .9rem 1rem;
  background: var(--green-xlight);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
}
.rd-info-item--full {
  grid-column: 1 / -1;
}
.rd-info-label {
  font-size: .73rem;
  font-weight: 600;
  color: var(--text-sub);
  text-transform: uppercase;
  letter-spacing: .04em;
}
.rd-info-value {
  font-size: .9rem;
  color: var(--text-main);
  font-weight: 500;
  line-height: 1.5;
}
.rd-days { font-size: .8rem; color: var(--text-sub); font-style: normal; }
.rd-flight-detail { font-size: .78rem; color: var(--text-sub); }
.rd-mt { margin-top: 1rem; }

/* =============================================
   정보 리스트 (모바일)
============================================= */
.rd-info-list { display: flex; flex-direction: column; gap: 0; }
.rd-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .75rem .2rem;
  border-bottom: 1px solid var(--border);
  gap: .5rem;
}
.rd-info-row:last-child { border-bottom: none; }
.rd-info-row .rd-info-label {
  flex: 0 0 auto;
  min-width: 95px;
  font-size: .75rem;
  color: var(--text-sub);
  font-weight: 600;
}
.rd-info-row .rd-info-value {
  text-align: right;
  font-size: .85rem;
  color: var(--text-main);
}
.rd-info-row--col {
  flex-direction: column;
  align-items: flex-start;
  gap: .4rem;
}
.rd-info-row--col .rd-info-value,
.rd-info-row--col .rd-info-label { text-align: left; }

/* =============================================
   Textarea
============================================= */
.rd-textarea {
  width: 100%;
  min-height: 80px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: .6rem .8rem;
  font-size: .82rem;
  color: var(--text-main);
  background: var(--white);
  resize: vertical;
  outline: none;
}
.rd-textarea:focus { border-color: var(--green); }

/* =============================================
   상태 배지
============================================= */
.rd-status-wrap { display: flex; flex-direction: column; gap: .35rem; align-items: flex-start; }
.rd-status-badge {
  display: inline-flex;
  align-items: center;
  font-size: .78rem;
  font-weight: 600;
  padding: .28rem .75rem;
  border-radius: 20px;
}
.rd-status--paid    { background: #fff3e0; color: #e65100; }
.rd-status--partial { background: #fff8e1; color: #f57c00; }
.rd-status--request { background: #e3f2fd; color: #1565c0; }
.rd-status--cancel  { background: #fce4ec; color: #b71c1c; }
.rd-status-text { font-size: .85rem; color: var(--text-main); }
.rd-cxl-badge {
  display: inline-flex;
  align-items: center;
  gap: .3rem;
  font-size: .76rem;
  font-weight: 600;
  color: #c62828;
  background: #ffebee;
  padding: .25rem .7rem;
  border-radius: 20px;
}
.rd-account-badge {
  font-size: .72rem;
  font-weight: 500;
  color: var(--text-sub);
  margin-left: .3rem;
}

/* =============================================
   섹션 서브 타이틀
============================================= */
.rd-section-sub-title {
  display: flex;
  align-items: center;
  gap: .4rem;
  font-size: .82rem;
  font-weight: 700;
  color: var(--charcoal);
  margin: 0 0 .7rem;
}
.rd-section-sub-title i { color: var(--green-dark); }

/* =============================================
   경로 아이템 (엔버스)
============================================= */
.rd-route-section { margin-top: 1.2rem; }
.rd-route-item {
  display: flex;
  align-items: center;
  gap: .8rem;
  padding: .65rem 1rem;
  background: var(--green-xlight);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  margin-bottom: .5rem;
  flex-wrap: wrap;
}
.rd-route-day {
  background: var(--charcoal);
  color: var(--white);
  font-size: .72rem;
  font-weight: 700;
  padding: .2rem .6rem;
  border-radius: 20px;
  flex-shrink: 0;
}
.rd-route-points {
  display: flex;
  align-items: center;
  gap: .4rem;
  flex: 1;
  flex-wrap: wrap;
}
.rd-route-dept { color: #1565c0; font-weight: 600; font-size: .85rem; }
.rd-route-via  { color: var(--green-dark); font-weight: 600; font-size: .85rem; }
.rd-route-arr  { color: #c62828; font-weight: 600; font-size: .85rem; }
.rd-route-arrow { color: var(--text-muted); font-size: .75rem; }
.rd-route-time { font-size: .78rem; color: var(--text-sub); flex-shrink: 0; }

/* 모바일 경로 */
.rd-route-item-mo { margin-top: .5rem; }
.rd-route-day-mo { font-size: .78rem; font-weight: 700; color: var(--charcoal); margin-bottom: .3rem; }
.rd-route-mo-grid {
  display: grid;
  grid-template-columns: 45px 1fr;
  gap: .2rem .5rem;
  font-size: .8rem;
  background: var(--green-xlight);
  padding: .6rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
}
.rd-route-mo-label { color: var(--text-sub); font-weight: 600; font-size: .72rem; }

/* =============================================
   옵션 섹션
============================================= */
.rd-option-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1.2rem;
}
.rd-option-box {
  background: var(--green-xlight);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 1rem;
}
.rd-option-box--full { grid-column: 1 / -1; }
.rd-option-item {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .4rem 0;
  border-bottom: 1px dashed var(--border);
  font-size: .85rem;
}
.rd-option-item:last-child { border-bottom: none; }
.rd-option-name { flex: 1; color: var(--text-main); }
.rd-option-qty { color: var(--text-sub); font-size: .78rem; }
.rd-option-price { margin-left: auto; }
.rd-empty-text { font-size: .82rem; color: var(--text-muted); }
.rd-option-item-mo { font-size: .82rem; color: var(--text-main); padding: .25rem 0; }

/* =============================================
   멤버십 배지
============================================= */
.rd-mem-badge {
  font-size: .72rem;
  font-weight: 700;
  padding: .2rem .7rem;
  border-radius: 20px;
  margin-left: auto;
}
.rd-mem--premium { color: goldenrod; }
.rd-mem--standard { color: royalblue; }
.rd-mem-benefit-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 0;
  border-top: 1px solid var(--border);
  margin-top: .5rem;
}
.rd-mem-benefit-label { font-size: .85rem; color: var(--text-main); }
.rd-mem-benefit-value { font-size: 1.1rem; font-weight: 700; white-space: nowrap; }
.rd-mem-note { font-size: .72rem; color: var(--text-sub); margin: .3rem 0 0; }

/* =============================================
   결제 정보
============================================= */
.rd-pay-summary {
  display: flex;
  flex-direction: column;
  gap: .5rem;
  padding: 1rem 1.2rem;
  background: var(--green-xlight);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  margin-bottom: 1rem;
}
.rd-pay-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.rd-pay-row--total {
  border-top: 1.5px solid var(--border);
  padding-top: .7rem;
  margin-top: .2rem;
}
.rd-pay-label { font-size: .85rem; color: var(--text-sub); font-weight: 600; }
.rd-pay-value { font-size: .9rem; color: var(--text-main); font-weight: 600; }
.rd-pay-value--discount { color: #1565c0; font-weight: 600; }
.rd-pay-value--total {
  font-size: 1.7rem;
  font-weight: 700;
  color: #c62828;
  line-height: 1;
}
.rd-pay-value--total em { font-style: normal; font-size: 1rem; margin-left: .15rem; }

.rd-pay-history {
  background: var(--green-xlight);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: .9rem 1.1rem;
  margin-bottom: 1rem;
}
.rd-pay-history-title {
  font-size: .75rem;
  font-weight: 700;
  color: var(--text-sub);
  letter-spacing: .06em;
  text-transform: uppercase;
  margin: 0 0 .6rem;
}
.rd-pay-history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: .83rem;
  padding: .32rem 0;
  border-bottom: 1px dashed var(--border);
  color: var(--text-main);
  gap: .5rem;
}
.rd-pay-history-item:last-child { border-bottom: none; }
.rd-pay-history-item small { color: var(--text-muted); }

/* PC 결제 상세 그리드 */
.rd-pay-detail-grid {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 1.5rem;
  align-items: start;
}
.rd-person-price { font-size: .85rem; }

/* 결제 버튼 */
.rd-pay-btn-wrap { margin: 1.2rem 0 .5rem; text-align: right; }
.rd-pay-btn {
  display: inline-flex;
  align-items: center;
  gap: .4rem;
  background: var(--green-dark);
  color: var(--white);
  border: none;
  border-radius: var(--radius-sm);
  padding: .75rem 2rem;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: background .2s, transform .15s;
}
.rd-pay-btn:hover { background: var(--charcoal); transform: translateY(-2px); }
.rd-pay-btn--free { background: var(--teal); }
.rd-pay-btn--free:hover { background: #2e8a58; }
.rd-pay-btn--balance { background: #1565c0; }
.rd-pay-btn--balance:hover { background: #0d47a1; }

/* 계좌 정보 */
.rd-bank-info {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: var(--radius-sm);
  padding: 1rem 1.2rem;
  margin-top: 1.2rem;
}
.rd-bank-title { font-size: .85rem; font-weight: 700; color: #5d4037; margin: 0 0 .5rem; }
.rd-bank-text  { font-size: .82rem; color: #5d4037; margin: 0 0 .4rem; }
.rd-bank-account { font-size: .9rem; font-weight: 700; color: #2e7d32; margin: .4rem 0; }
.rd-bank-sub { font-size: .78rem; color: #795548; margin: .2rem 0 0; }

/* 모바일 취소 버튼 */
.rd-cxl-btn {
  background: transparent;
  border: 1px solid #e53935;
  color: #e53935;
  font-size: .78rem;
  font-weight: 600;
  padding: .3rem .8rem;
  border-radius: var(--radius-sm);
  cursor: pointer;
}
.rd-cxl-btn:hover { background: #ffebee; }

/* =============================================
   하단 버튼
============================================= */
.rd-footer-btns {
  display: flex;
  gap: 1rem;
  justify-content: center;
  padding: 1.5rem 0 2rem;
  flex-wrap: wrap;
}
.rd-footer-btn {
  display: inline-flex;
  align-items: center;
  gap: .4rem;
  padding: .75rem 2rem;
  font-size: .95rem;
  font-weight: 600;
  border-radius: var(--radius-sm);
  cursor: pointer;
  border: none;
  transition: background .2s, transform .15s;
  min-width: 160px;
  justify-content: center;
}
.rd-footer-btn--main {
  background: var(--charcoal);
  color: var(--white);
}
.rd-footer-btn--main:hover { background: var(--charcoal-light, #3d5c3d); transform: translateY(-2px); }
.rd-footer-btn--cancel {
  background: #b71c1c;
  color: var(--white);
}
.rd-footer-btn--cancel:hover:not(:disabled) { background: #c62828; transform: translateY(-2px); }
.rd-footer-btn--cancel:disabled { background: #aaa; cursor: not-allowed; }

@media (max-width: 767px) {
  .rd-footer-btns { flex-direction: column; padding: 1rem; }
  .rd-footer-btn { width: 100%; }
  .rd-pay-detail-grid { grid-template-columns: 1fr; }
  .rd-option-section { grid-template-columns: 1fr; }
  .rd-info-grid { grid-template-columns: 1fr; }
}

/* SweetAlert 커스텀 */
.swal-popup { font-size: .85rem; overflow: hidden; word-wrap: break-word; }

/** 
  * 호텔예약
*/
.status-badge-h {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 20px;
}
.status-h-wait   { background: #fffbe6; color: #b07d00; }
.status-h-done   { background: #e6f4ea; color: #2d6a4f; }
.status-h-cancel { background: #f4f4f4; color: #aaa; }
.status-h-danger { background: #fff0f0; color: #e63946; }
</style>